(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined")
      return require.apply(this, arguments);
    throw Error('Dynamic require of "' + x + '" is not supported');
  });
  var __commonJS = (cb, mod) => function __require2() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/localforage/dist/localforage.js
  var require_localforage = __commonJS({
    "node_modules/localforage/dist/localforage.js"(exports, module) {
      /*!
          localForage -- Offline Storage, Improved
          Version 1.10.0
          https://localforage.github.io/localForage
          (c) 2013-2017 Mozilla, Apache License 2.0
      */
      (function(f) {
        if (typeof exports === "object" && typeof module !== "undefined") {
          module.exports = f();
        } else if (typeof define === "function" && define.amd) {
          define([], f);
        } else {
          var g;
          if (typeof window !== "undefined") {
            g = window;
          } else if (typeof global !== "undefined") {
            g = global;
          } else if (typeof self !== "undefined") {
            g = self;
          } else {
            g = this;
          }
          g.localforage = f();
        }
      })(function() {
        var define2, module2, exports2;
        return function e(t, n, r) {
          function s(o2, u) {
            if (!n[o2]) {
              if (!t[o2]) {
                var a = typeof __require == "function" && __require;
                if (!u && a)
                  return a(o2, true);
                if (i)
                  return i(o2, true);
                var f = new Error("Cannot find module '" + o2 + "'");
                throw f.code = "MODULE_NOT_FOUND", f;
              }
              var l = n[o2] = { exports: {} };
              t[o2][0].call(l.exports, function(e2) {
                var n2 = t[o2][1][e2];
                return s(n2 ? n2 : e2);
              }, l, l.exports, e, t, n, r);
            }
            return n[o2].exports;
          }
          var i = typeof __require == "function" && __require;
          for (var o = 0; o < r.length; o++)
            s(r[o]);
          return s;
        }({ 1: [function(_dereq_, module3, exports3) {
          (function(global2) {
            "use strict";
            var Mutation = global2.MutationObserver || global2.WebKitMutationObserver;
            var scheduleDrain;
            {
              if (Mutation) {
                var called = 0;
                var observer = new Mutation(nextTick);
                var element = global2.document.createTextNode("");
                observer.observe(element, {
                  characterData: true
                });
                scheduleDrain = function() {
                  element.data = called = ++called % 2;
                };
              } else if (!global2.setImmediate && typeof global2.MessageChannel !== "undefined") {
                var channel = new global2.MessageChannel();
                channel.port1.onmessage = nextTick;
                scheduleDrain = function() {
                  channel.port2.postMessage(0);
                };
              } else if ("document" in global2 && "onreadystatechange" in global2.document.createElement("script")) {
                scheduleDrain = function() {
                  var scriptEl = global2.document.createElement("script");
                  scriptEl.onreadystatechange = function() {
                    nextTick();
                    scriptEl.onreadystatechange = null;
                    scriptEl.parentNode.removeChild(scriptEl);
                    scriptEl = null;
                  };
                  global2.document.documentElement.appendChild(scriptEl);
                };
              } else {
                scheduleDrain = function() {
                  setTimeout(nextTick, 0);
                };
              }
            }
            var draining;
            var queue = [];
            function nextTick() {
              draining = true;
              var i, oldQueue;
              var len = queue.length;
              while (len) {
                oldQueue = queue;
                queue = [];
                i = -1;
                while (++i < len) {
                  oldQueue[i]();
                }
                len = queue.length;
              }
              draining = false;
            }
            module3.exports = immediate;
            function immediate(task) {
              if (queue.push(task) === 1 && !draining) {
                scheduleDrain();
              }
            }
          }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, {}], 2: [function(_dereq_, module3, exports3) {
          "use strict";
          var immediate = _dereq_(1);
          function INTERNAL() {
          }
          var handlers = {};
          var REJECTED = ["REJECTED"];
          var FULFILLED = ["FULFILLED"];
          var PENDING = ["PENDING"];
          module3.exports = Promise2;
          function Promise2(resolver) {
            if (typeof resolver !== "function") {
              throw new TypeError("resolver must be a function");
            }
            this.state = PENDING;
            this.queue = [];
            this.outcome = void 0;
            if (resolver !== INTERNAL) {
              safelyResolveThenable(this, resolver);
            }
          }
          Promise2.prototype["catch"] = function(onRejected) {
            return this.then(null, onRejected);
          };
          Promise2.prototype.then = function(onFulfilled, onRejected) {
            if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) {
              return this;
            }
            var promise = new this.constructor(INTERNAL);
            if (this.state !== PENDING) {
              var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
              unwrap(promise, resolver, this.outcome);
            } else {
              this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
            }
            return promise;
          };
          function QueueItem(promise, onFulfilled, onRejected) {
            this.promise = promise;
            if (typeof onFulfilled === "function") {
              this.onFulfilled = onFulfilled;
              this.callFulfilled = this.otherCallFulfilled;
            }
            if (typeof onRejected === "function") {
              this.onRejected = onRejected;
              this.callRejected = this.otherCallRejected;
            }
          }
          QueueItem.prototype.callFulfilled = function(value) {
            handlers.resolve(this.promise, value);
          };
          QueueItem.prototype.otherCallFulfilled = function(value) {
            unwrap(this.promise, this.onFulfilled, value);
          };
          QueueItem.prototype.callRejected = function(value) {
            handlers.reject(this.promise, value);
          };
          QueueItem.prototype.otherCallRejected = function(value) {
            unwrap(this.promise, this.onRejected, value);
          };
          function unwrap(promise, func, value) {
            immediate(function() {
              var returnValue;
              try {
                returnValue = func(value);
              } catch (e) {
                return handlers.reject(promise, e);
              }
              if (returnValue === promise) {
                handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
              } else {
                handlers.resolve(promise, returnValue);
              }
            });
          }
          handlers.resolve = function(self2, value) {
            var result = tryCatch(getThen, value);
            if (result.status === "error") {
              return handlers.reject(self2, result.value);
            }
            var thenable = result.value;
            if (thenable) {
              safelyResolveThenable(self2, thenable);
            } else {
              self2.state = FULFILLED;
              self2.outcome = value;
              var i = -1;
              var len = self2.queue.length;
              while (++i < len) {
                self2.queue[i].callFulfilled(value);
              }
            }
            return self2;
          };
          handlers.reject = function(self2, error) {
            self2.state = REJECTED;
            self2.outcome = error;
            var i = -1;
            var len = self2.queue.length;
            while (++i < len) {
              self2.queue[i].callRejected(error);
            }
            return self2;
          };
          function getThen(obj) {
            var then = obj && obj.then;
            if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") {
              return function appyThen() {
                then.apply(obj, arguments);
              };
            }
          }
          function safelyResolveThenable(self2, thenable) {
            var called = false;
            function onError(value) {
              if (called) {
                return;
              }
              called = true;
              handlers.reject(self2, value);
            }
            function onSuccess(value) {
              if (called) {
                return;
              }
              called = true;
              handlers.resolve(self2, value);
            }
            function tryToUnwrap() {
              thenable(onSuccess, onError);
            }
            var result = tryCatch(tryToUnwrap);
            if (result.status === "error") {
              onError(result.value);
            }
          }
          function tryCatch(func, value) {
            var out = {};
            try {
              out.value = func(value);
              out.status = "success";
            } catch (e) {
              out.status = "error";
              out.value = e;
            }
            return out;
          }
          Promise2.resolve = resolve;
          function resolve(value) {
            if (value instanceof this) {
              return value;
            }
            return handlers.resolve(new this(INTERNAL), value);
          }
          Promise2.reject = reject;
          function reject(reason) {
            var promise = new this(INTERNAL);
            return handlers.reject(promise, reason);
          }
          Promise2.all = all;
          function all(iterable) {
            var self2 = this;
            if (Object.prototype.toString.call(iterable) !== "[object Array]") {
              return this.reject(new TypeError("must be an array"));
            }
            var len = iterable.length;
            var called = false;
            if (!len) {
              return this.resolve([]);
            }
            var values = new Array(len);
            var resolved = 0;
            var i = -1;
            var promise = new this(INTERNAL);
            while (++i < len) {
              allResolver(iterable[i], i);
            }
            return promise;
            function allResolver(value, i2) {
              self2.resolve(value).then(resolveFromAll, function(error) {
                if (!called) {
                  called = true;
                  handlers.reject(promise, error);
                }
              });
              function resolveFromAll(outValue) {
                values[i2] = outValue;
                if (++resolved === len && !called) {
                  called = true;
                  handlers.resolve(promise, values);
                }
              }
            }
          }
          Promise2.race = race;
          function race(iterable) {
            var self2 = this;
            if (Object.prototype.toString.call(iterable) !== "[object Array]") {
              return this.reject(new TypeError("must be an array"));
            }
            var len = iterable.length;
            var called = false;
            if (!len) {
              return this.resolve([]);
            }
            var i = -1;
            var promise = new this(INTERNAL);
            while (++i < len) {
              resolver(iterable[i]);
            }
            return promise;
            function resolver(value) {
              self2.resolve(value).then(function(response) {
                if (!called) {
                  called = true;
                  handlers.resolve(promise, response);
                }
              }, function(error) {
                if (!called) {
                  called = true;
                  handlers.reject(promise, error);
                }
              });
            }
          }
        }, { "1": 1 }], 3: [function(_dereq_, module3, exports3) {
          (function(global2) {
            "use strict";
            if (typeof global2.Promise !== "function") {
              global2.Promise = _dereq_(2);
            }
          }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, { "2": 2 }], 4: [function(_dereq_, module3, exports3) {
          "use strict";
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function getIDB() {
            try {
              if (typeof indexedDB !== "undefined") {
                return indexedDB;
              }
              if (typeof webkitIndexedDB !== "undefined") {
                return webkitIndexedDB;
              }
              if (typeof mozIndexedDB !== "undefined") {
                return mozIndexedDB;
              }
              if (typeof OIndexedDB !== "undefined") {
                return OIndexedDB;
              }
              if (typeof msIndexedDB !== "undefined") {
                return msIndexedDB;
              }
            } catch (e) {
              return;
            }
          }
          var idb = getIDB();
          function isIndexedDBValid() {
            try {
              if (!idb || !idb.open) {
                return false;
              }
              var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
              var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
              return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
              // and HTC Android devices <4.4 are missing IDBKeyRange
              // See: https://github.com/mozilla/localForage/issues/128
              // See: https://github.com/mozilla/localForage/issues/272
              typeof IDBKeyRange !== "undefined";
            } catch (e) {
              return false;
            }
          }
          function createBlob(parts, properties) {
            parts = parts || [];
            properties = properties || {};
            try {
              return new Blob(parts, properties);
            } catch (e) {
              if (e.name !== "TypeError") {
                throw e;
              }
              var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
              var builder = new Builder();
              for (var i = 0; i < parts.length; i += 1) {
                builder.append(parts[i]);
              }
              return builder.getBlob(properties.type);
            }
          }
          if (typeof Promise === "undefined") {
            _dereq_(3);
          }
          var Promise$1 = Promise;
          function executeCallback(promise, callback) {
            if (callback) {
              promise.then(function(result) {
                callback(null, result);
              }, function(error) {
                callback(error);
              });
            }
          }
          function executeTwoCallbacks(promise, callback, errorCallback) {
            if (typeof callback === "function") {
              promise.then(callback);
            }
            if (typeof errorCallback === "function") {
              promise["catch"](errorCallback);
            }
          }
          function normalizeKey(key2) {
            if (typeof key2 !== "string") {
              console.warn(key2 + " used as a key, but it is not a string.");
              key2 = String(key2);
            }
            return key2;
          }
          function getCallback() {
            if (arguments.length && typeof arguments[arguments.length - 1] === "function") {
              return arguments[arguments.length - 1];
            }
          }
          var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
          var supportsBlobs = void 0;
          var dbContexts = {};
          var toString = Object.prototype.toString;
          var READ_ONLY = "readonly";
          var READ_WRITE = "readwrite";
          function _binStringToArrayBuffer(bin) {
            var length2 = bin.length;
            var buf = new ArrayBuffer(length2);
            var arr = new Uint8Array(buf);
            for (var i = 0; i < length2; i++) {
              arr[i] = bin.charCodeAt(i);
            }
            return buf;
          }
          function _checkBlobSupportWithoutCaching(idb2) {
            return new Promise$1(function(resolve) {
              var txn = idb2.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
              var blob = createBlob([""]);
              txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
              txn.onabort = function(e) {
                e.preventDefault();
                e.stopPropagation();
                resolve(false);
              };
              txn.oncomplete = function() {
                var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                var matchedEdge = navigator.userAgent.match(/Edge\//);
                resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
              };
            })["catch"](function() {
              return false;
            });
          }
          function _checkBlobSupport(idb2) {
            if (typeof supportsBlobs === "boolean") {
              return Promise$1.resolve(supportsBlobs);
            }
            return _checkBlobSupportWithoutCaching(idb2).then(function(value) {
              supportsBlobs = value;
              return supportsBlobs;
            });
          }
          function _deferReadiness(dbInfo) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = {};
            deferredOperation.promise = new Promise$1(function(resolve, reject) {
              deferredOperation.resolve = resolve;
              deferredOperation.reject = reject;
            });
            dbContext.deferredOperations.push(deferredOperation);
            if (!dbContext.dbReady) {
              dbContext.dbReady = deferredOperation.promise;
            } else {
              dbContext.dbReady = dbContext.dbReady.then(function() {
                return deferredOperation.promise;
              });
            }
          }
          function _advanceReadiness(dbInfo) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = dbContext.deferredOperations.pop();
            if (deferredOperation) {
              deferredOperation.resolve();
              return deferredOperation.promise;
            }
          }
          function _rejectReadiness(dbInfo, err) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = dbContext.deferredOperations.pop();
            if (deferredOperation) {
              deferredOperation.reject(err);
              return deferredOperation.promise;
            }
          }
          function _getConnection(dbInfo, upgradeNeeded) {
            return new Promise$1(function(resolve, reject) {
              dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
              if (dbInfo.db) {
                if (upgradeNeeded) {
                  _deferReadiness(dbInfo);
                  dbInfo.db.close();
                } else {
                  return resolve(dbInfo.db);
                }
              }
              var dbArgs = [dbInfo.name];
              if (upgradeNeeded) {
                dbArgs.push(dbInfo.version);
              }
              var openreq = idb.open.apply(idb, dbArgs);
              if (upgradeNeeded) {
                openreq.onupgradeneeded = function(e) {
                  var db = openreq.result;
                  try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                      db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                  } catch (ex) {
                    if (ex.name === "ConstraintError") {
                      console.warn('The database "' + dbInfo.name + '" has been upgraded from version ' + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                      throw ex;
                    }
                  }
                };
              }
              openreq.onerror = function(e) {
                e.preventDefault();
                reject(openreq.error);
              };
              openreq.onsuccess = function() {
                var db = openreq.result;
                db.onversionchange = function(e) {
                  e.target.close();
                };
                resolve(db);
                _advanceReadiness(dbInfo);
              };
            });
          }
          function _getOriginalConnection(dbInfo) {
            return _getConnection(dbInfo, false);
          }
          function _getUpgradedConnection(dbInfo) {
            return _getConnection(dbInfo, true);
          }
          function _isUpgradeNeeded(dbInfo, defaultVersion) {
            if (!dbInfo.db) {
              return true;
            }
            var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
            var isDowngrade = dbInfo.version < dbInfo.db.version;
            var isUpgrade = dbInfo.version > dbInfo.db.version;
            if (isDowngrade) {
              if (dbInfo.version !== defaultVersion) {
                console.warn('The database "' + dbInfo.name + `" can't be downgraded from version ` + dbInfo.db.version + " to version " + dbInfo.version + ".");
              }
              dbInfo.version = dbInfo.db.version;
            }
            if (isUpgrade || isNewStore) {
              if (isNewStore) {
                var incVersion = dbInfo.db.version + 1;
                if (incVersion > dbInfo.version) {
                  dbInfo.version = incVersion;
                }
              }
              return true;
            }
            return false;
          }
          function _encodeBlob(blob) {
            return new Promise$1(function(resolve, reject) {
              var reader = new FileReader();
              reader.onerror = reject;
              reader.onloadend = function(e) {
                var base64 = btoa(e.target.result || "");
                resolve({
                  __local_forage_encoded_blob: true,
                  data: base64,
                  type: blob.type
                });
              };
              reader.readAsBinaryString(blob);
            });
          }
          function _decodeBlob(encodedBlob) {
            var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
            return createBlob([arrayBuff], { type: encodedBlob.type });
          }
          function _isEncodedBlob(value) {
            return value && value.__local_forage_encoded_blob;
          }
          function _fullyReady(callback) {
            var self2 = this;
            var promise = self2._initReady().then(function() {
              var dbContext = dbContexts[self2._dbInfo.name];
              if (dbContext && dbContext.dbReady) {
                return dbContext.dbReady;
              }
            });
            executeTwoCallbacks(promise, callback, callback);
            return promise;
          }
          function _tryReconnect(dbInfo) {
            _deferReadiness(dbInfo);
            var dbContext = dbContexts[dbInfo.name];
            var forages = dbContext.forages;
            for (var i = 0; i < forages.length; i++) {
              var forage = forages[i];
              if (forage._dbInfo.db) {
                forage._dbInfo.db.close();
                forage._dbInfo.db = null;
              }
            }
            dbInfo.db = null;
            return _getOriginalConnection(dbInfo).then(function(db) {
              dbInfo.db = db;
              if (_isUpgradeNeeded(dbInfo)) {
                return _getUpgradedConnection(dbInfo);
              }
              return db;
            }).then(function(db) {
              dbInfo.db = dbContext.db = db;
              for (var i2 = 0; i2 < forages.length; i2++) {
                forages[i2]._dbInfo.db = db;
              }
            })["catch"](function(err) {
              _rejectReadiness(dbInfo, err);
              throw err;
            });
          }
          function createTransaction(dbInfo, mode, callback, retries) {
            if (retries === void 0) {
              retries = 1;
            }
            try {
              var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
              callback(null, tx);
            } catch (err) {
              if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) {
                return Promise$1.resolve().then(function() {
                  if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    if (dbInfo.db) {
                      dbInfo.version = dbInfo.db.version + 1;
                    }
                    return _getUpgradedConnection(dbInfo);
                  }
                }).then(function() {
                  return _tryReconnect(dbInfo).then(function() {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                  });
                })["catch"](callback);
              }
              callback(err);
            }
          }
          function createDbContext() {
            return {
              // Running localForages sharing a database.
              forages: [],
              // Shared database.
              db: null,
              // Database readiness (promise).
              dbReady: null,
              // Deferred operations on the database.
              deferredOperations: []
            };
          }
          function _initStorage(options) {
            var self2 = this;
            var dbInfo = {
              db: null
            };
            if (options) {
              for (var i in options) {
                dbInfo[i] = options[i];
              }
            }
            var dbContext = dbContexts[dbInfo.name];
            if (!dbContext) {
              dbContext = createDbContext();
              dbContexts[dbInfo.name] = dbContext;
            }
            dbContext.forages.push(self2);
            if (!self2._initReady) {
              self2._initReady = self2.ready;
              self2.ready = _fullyReady;
            }
            var initPromises = [];
            function ignoreErrors() {
              return Promise$1.resolve();
            }
            for (var j = 0; j < dbContext.forages.length; j++) {
              var forage = dbContext.forages[j];
              if (forage !== self2) {
                initPromises.push(forage._initReady()["catch"](ignoreErrors));
              }
            }
            var forages = dbContext.forages.slice(0);
            return Promise$1.all(initPromises).then(function() {
              dbInfo.db = dbContext.db;
              return _getOriginalConnection(dbInfo);
            }).then(function(db) {
              dbInfo.db = db;
              if (_isUpgradeNeeded(dbInfo, self2._defaultConfig.version)) {
                return _getUpgradedConnection(dbInfo);
              }
              return db;
            }).then(function(db) {
              dbInfo.db = dbContext.db = db;
              self2._dbInfo = dbInfo;
              for (var k = 0; k < forages.length; k++) {
                var forage2 = forages[k];
                if (forage2 !== self2) {
                  forage2._dbInfo.db = dbInfo.db;
                  forage2._dbInfo.version = dbInfo.version;
                }
              }
            });
          }
          function getItem(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.get(key2);
                    req.onsuccess = function() {
                      var value = req.result;
                      if (value === void 0) {
                        value = null;
                      }
                      if (_isEncodedBlob(value)) {
                        value = _decodeBlob(value);
                      }
                      resolve(value);
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate(iterator, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (cursor) {
                        var value = cursor.value;
                        if (_isEncodedBlob(value)) {
                          value = _decodeBlob(value);
                        }
                        var result = iterator(value, cursor.key, iterationNumber++);
                        if (result !== void 0) {
                          resolve(result);
                        } else {
                          cursor["continue"]();
                        }
                      } else {
                        resolve();
                      }
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem(key2, value, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              var dbInfo;
              self2.ready().then(function() {
                dbInfo = self2._dbInfo;
                if (toString.call(value) === "[object Blob]") {
                  return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                    if (blobSupport) {
                      return value;
                    }
                    return _encodeBlob(value);
                  });
                }
                return value;
              }).then(function(value2) {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    if (value2 === null) {
                      value2 = void 0;
                    }
                    var req = store.put(value2, key2);
                    transaction.oncomplete = function() {
                      if (value2 === void 0) {
                        value2 = null;
                      }
                      resolve(value2);
                    };
                    transaction.onabort = transaction.onerror = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function removeItem(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store["delete"](key2);
                    transaction.oncomplete = function() {
                      resolve();
                    };
                    transaction.onerror = function() {
                      reject(req.error);
                    };
                    transaction.onabort = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function clear(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.clear();
                    transaction.oncomplete = function() {
                      resolve();
                    };
                    transaction.onabort = transaction.onerror = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.count();
                    req.onsuccess = function() {
                      resolve(req.result);
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key(n, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              if (n < 0) {
                resolve(null);
                return;
              }
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (!cursor) {
                        resolve(null);
                        return;
                      }
                      if (n === 0) {
                        resolve(cursor.key);
                      } else {
                        if (!advanced) {
                          advanced = true;
                          cursor.advance(n);
                        } else {
                          resolve(cursor.key);
                        }
                      }
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys2 = [];
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (!cursor) {
                        resolve(keys2);
                        return;
                      }
                      keys2.push(cursor.key);
                      cursor["continue"]();
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function dropInstance(options, callback) {
            callback = getCallback.apply(this, arguments);
            var currentConfig = this.config();
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              var isCurrentDb = options.name === currentConfig.name && self2._dbInfo.db;
              var dbPromise = isCurrentDb ? Promise$1.resolve(self2._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;
                dbContext.db = db;
                for (var i = 0; i < forages.length; i++) {
                  forages[i]._dbInfo.db = db;
                }
                return db;
              });
              if (!options.storeName) {
                promise = dbPromise.then(function(db) {
                  _deferReadiness(options);
                  var dbContext = dbContexts[options.name];
                  var forages = dbContext.forages;
                  db.close();
                  for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                  }
                  var dropDBPromise = new Promise$1(function(resolve, reject) {
                    var req = idb.deleteDatabase(options.name);
                    req.onerror = function() {
                      var db2 = req.result;
                      if (db2) {
                        db2.close();
                      }
                      reject(req.error);
                    };
                    req.onblocked = function() {
                      console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                    };
                    req.onsuccess = function() {
                      var db2 = req.result;
                      if (db2) {
                        db2.close();
                      }
                      resolve(db2);
                    };
                  });
                  return dropDBPromise.then(function(db2) {
                    dbContext.db = db2;
                    for (var i2 = 0; i2 < forages.length; i2++) {
                      var _forage = forages[i2];
                      _advanceReadiness(_forage._dbInfo);
                    }
                  })["catch"](function(err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                    });
                    throw err;
                  });
                });
              } else {
                promise = dbPromise.then(function(db) {
                  if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                  }
                  var newVersion = db.version + 1;
                  _deferReadiness(options);
                  var dbContext = dbContexts[options.name];
                  var forages = dbContext.forages;
                  db.close();
                  for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                  }
                  var dropObjectPromise = new Promise$1(function(resolve, reject) {
                    var req = idb.open(options.name, newVersion);
                    req.onerror = function(err) {
                      var db2 = req.result;
                      db2.close();
                      reject(err);
                    };
                    req.onupgradeneeded = function() {
                      var db2 = req.result;
                      db2.deleteObjectStore(options.storeName);
                    };
                    req.onsuccess = function() {
                      var db2 = req.result;
                      db2.close();
                      resolve(db2);
                    };
                  });
                  return dropObjectPromise.then(function(db2) {
                    dbContext.db = db2;
                    for (var j = 0; j < forages.length; j++) {
                      var _forage2 = forages[j];
                      _forage2._dbInfo.db = db2;
                      _advanceReadiness(_forage2._dbInfo);
                    }
                  })["catch"](function(err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                    });
                    throw err;
                  });
                });
              }
            }
            executeCallback(promise, callback);
            return promise;
          }
          var asyncStorage = {
            _driver: "asyncStorage",
            _initStorage,
            _support: isIndexedDBValid(),
            iterate,
            getItem,
            setItem,
            removeItem,
            clear,
            length,
            key,
            keys,
            dropInstance
          };
          function isWebSQLValid() {
            return typeof openDatabase === "function";
          }
          var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          var BLOB_TYPE_PREFIX = "~~local_forage_type~";
          var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
          var SERIALIZED_MARKER = "__lfsc__:";
          var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
          var TYPE_ARRAYBUFFER = "arbf";
          var TYPE_BLOB = "blob";
          var TYPE_INT8ARRAY = "si08";
          var TYPE_UINT8ARRAY = "ui08";
          var TYPE_UINT8CLAMPEDARRAY = "uic8";
          var TYPE_INT16ARRAY = "si16";
          var TYPE_INT32ARRAY = "si32";
          var TYPE_UINT16ARRAY = "ur16";
          var TYPE_UINT32ARRAY = "ui32";
          var TYPE_FLOAT32ARRAY = "fl32";
          var TYPE_FLOAT64ARRAY = "fl64";
          var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
          var toString$1 = Object.prototype.toString;
          function stringToBuffer(serializedString) {
            var bufferLength = serializedString.length * 0.75;
            var len = serializedString.length;
            var i;
            var p = 0;
            var encoded1, encoded2, encoded3, encoded4;
            if (serializedString[serializedString.length - 1] === "=") {
              bufferLength--;
              if (serializedString[serializedString.length - 2] === "=") {
                bufferLength--;
              }
            }
            var buffer = new ArrayBuffer(bufferLength);
            var bytes = new Uint8Array(buffer);
            for (i = 0; i < len; i += 4) {
              encoded1 = BASE_CHARS.indexOf(serializedString[i]);
              encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
              encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
              encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
              bytes[p++] = encoded1 << 2 | encoded2 >> 4;
              bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
              bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
            }
            return buffer;
          }
          function bufferToString(buffer) {
            var bytes = new Uint8Array(buffer);
            var base64String = "";
            var i;
            for (i = 0; i < bytes.length; i += 3) {
              base64String += BASE_CHARS[bytes[i] >> 2];
              base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
              base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
              base64String += BASE_CHARS[bytes[i + 2] & 63];
            }
            if (bytes.length % 3 === 2) {
              base64String = base64String.substring(0, base64String.length - 1) + "=";
            } else if (bytes.length % 3 === 1) {
              base64String = base64String.substring(0, base64String.length - 2) + "==";
            }
            return base64String;
          }
          function serialize(value, callback) {
            var valueType = "";
            if (value) {
              valueType = toString$1.call(value);
            }
            if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
              var buffer;
              var marker = SERIALIZED_MARKER;
              if (value instanceof ArrayBuffer) {
                buffer = value;
                marker += TYPE_ARRAYBUFFER;
              } else {
                buffer = value.buffer;
                if (valueType === "[object Int8Array]") {
                  marker += TYPE_INT8ARRAY;
                } else if (valueType === "[object Uint8Array]") {
                  marker += TYPE_UINT8ARRAY;
                } else if (valueType === "[object Uint8ClampedArray]") {
                  marker += TYPE_UINT8CLAMPEDARRAY;
                } else if (valueType === "[object Int16Array]") {
                  marker += TYPE_INT16ARRAY;
                } else if (valueType === "[object Uint16Array]") {
                  marker += TYPE_UINT16ARRAY;
                } else if (valueType === "[object Int32Array]") {
                  marker += TYPE_INT32ARRAY;
                } else if (valueType === "[object Uint32Array]") {
                  marker += TYPE_UINT32ARRAY;
                } else if (valueType === "[object Float32Array]") {
                  marker += TYPE_FLOAT32ARRAY;
                } else if (valueType === "[object Float64Array]") {
                  marker += TYPE_FLOAT64ARRAY;
                } else {
                  callback(new Error("Failed to get type for BinaryArray"));
                }
              }
              callback(marker + bufferToString(buffer));
            } else if (valueType === "[object Blob]") {
              var fileReader = new FileReader();
              fileReader.onload = function() {
                var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                callback(SERIALIZED_MARKER + TYPE_BLOB + str);
              };
              fileReader.readAsArrayBuffer(value);
            } else {
              try {
                callback(JSON.stringify(value));
              } catch (e) {
                console.error("Couldn't convert value into a JSON string: ", value);
                callback(null, e);
              }
            }
          }
          function deserialize(value) {
            if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
              return JSON.parse(value);
            }
            var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
            var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
            var blobType;
            if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
              var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
              blobType = matcher[1];
              serializedString = serializedString.substring(matcher[0].length);
            }
            var buffer = stringToBuffer(serializedString);
            switch (type) {
              case TYPE_ARRAYBUFFER:
                return buffer;
              case TYPE_BLOB:
                return createBlob([buffer], { type: blobType });
              case TYPE_INT8ARRAY:
                return new Int8Array(buffer);
              case TYPE_UINT8ARRAY:
                return new Uint8Array(buffer);
              case TYPE_UINT8CLAMPEDARRAY:
                return new Uint8ClampedArray(buffer);
              case TYPE_INT16ARRAY:
                return new Int16Array(buffer);
              case TYPE_UINT16ARRAY:
                return new Uint16Array(buffer);
              case TYPE_INT32ARRAY:
                return new Int32Array(buffer);
              case TYPE_UINT32ARRAY:
                return new Uint32Array(buffer);
              case TYPE_FLOAT32ARRAY:
                return new Float32Array(buffer);
              case TYPE_FLOAT64ARRAY:
                return new Float64Array(buffer);
              default:
                throw new Error("Unkown type: " + type);
            }
          }
          var localforageSerializer = {
            serialize,
            deserialize,
            stringToBuffer,
            bufferToString
          };
          function createDbTable(t, dbInfo, callback, errorCallback) {
            t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
          }
          function _initStorage$1(options) {
            var self2 = this;
            var dbInfo = {
              db: null
            };
            if (options) {
              for (var i in options) {
                dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
              }
            }
            var dbInfoPromise = new Promise$1(function(resolve, reject) {
              try {
                dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
              } catch (e) {
                return reject(e);
              }
              dbInfo.db.transaction(function(t) {
                createDbTable(t, dbInfo, function() {
                  self2._dbInfo = dbInfo;
                  resolve();
                }, function(t2, error) {
                  reject(error);
                });
              }, reject);
            });
            dbInfo.serializer = localforageSerializer;
            return dbInfoPromise;
          }
          function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
            t.executeSql(sqlStatement, args, callback, function(t2, error) {
              if (error.code === error.SYNTAX_ERR) {
                t2.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [dbInfo.storeName], function(t3, results) {
                  if (!results.rows.length) {
                    createDbTable(t3, dbInfo, function() {
                      t3.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                  } else {
                    errorCallback(t3, error);
                  }
                }, errorCallback);
              } else {
                errorCallback(t2, error);
              }
            }, errorCallback);
          }
          function getItem$1(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [key2], function(t2, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;
                    if (result) {
                      result = dbInfo.serializer.deserialize(result);
                    }
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate$1(iterator, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t2, results) {
                    var rows = results.rows;
                    var length2 = rows.length;
                    for (var i = 0; i < length2; i++) {
                      var item = rows.item(i);
                      var result = item.value;
                      if (result) {
                        result = dbInfo.serializer.deserialize(result);
                      }
                      result = iterator(result, item.key, i + 1);
                      if (result !== void 0) {
                        resolve(result);
                        return;
                      }
                    }
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function _setItem(key2, value, callback, retriesLeft) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                if (value === void 0) {
                  value = null;
                }
                var originalValue = value;
                var dbInfo = self2._dbInfo;
                dbInfo.serializer.serialize(value, function(value2, error) {
                  if (error) {
                    reject(error);
                  } else {
                    dbInfo.db.transaction(function(t) {
                      tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " (key, value) VALUES (?, ?)", [key2, value2], function() {
                        resolve(originalValue);
                      }, function(t2, error2) {
                        reject(error2);
                      });
                    }, function(sqlError) {
                      if (sqlError.code === sqlError.QUOTA_ERR) {
                        if (retriesLeft > 0) {
                          resolve(_setItem.apply(self2, [key2, originalValue, callback, retriesLeft - 1]));
                          return;
                        }
                        reject(sqlError);
                      }
                    });
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem$1(key2, value, callback) {
            return _setItem.apply(this, [key2, value, callback, 1]);
          }
          function removeItem$1(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [key2], function() {
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function clear$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t2, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key$1(n, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [n + 1], function(t2, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t2, results) {
                    var keys2 = [];
                    for (var i = 0; i < results.rows.length; i++) {
                      keys2.push(results.rows.item(i).key);
                    }
                    resolve(keys2);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function getAllStoreNames(db) {
            return new Promise$1(function(resolve, reject) {
              db.transaction(function(t) {
                t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t2, results) {
                  var storeNames = [];
                  for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                  }
                  resolve({
                    db,
                    storeNames
                  });
                }, function(t2, error) {
                  reject(error);
                });
              }, function(sqlError) {
                reject(sqlError);
              });
            });
          }
          function dropInstance$1(options, callback) {
            callback = getCallback.apply(this, arguments);
            var currentConfig = this.config();
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              promise = new Promise$1(function(resolve) {
                var db;
                if (options.name === currentConfig.name) {
                  db = self2._dbInfo.db;
                } else {
                  db = openDatabase(options.name, "", "", 0);
                }
                if (!options.storeName) {
                  resolve(getAllStoreNames(db));
                } else {
                  resolve({
                    db,
                    storeNames: [options.storeName]
                  });
                }
              }).then(function(operationInfo) {
                return new Promise$1(function(resolve, reject) {
                  operationInfo.db.transaction(function(t) {
                    function dropTable(storeName) {
                      return new Promise$1(function(resolve2, reject2) {
                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                          resolve2();
                        }, function(t2, error) {
                          reject2(error);
                        });
                      });
                    }
                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                      operations.push(dropTable(operationInfo.storeNames[i]));
                    }
                    Promise$1.all(operations).then(function() {
                      resolve();
                    })["catch"](function(e) {
                      reject(e);
                    });
                  }, function(sqlError) {
                    reject(sqlError);
                  });
                });
              });
            }
            executeCallback(promise, callback);
            return promise;
          }
          var webSQLStorage = {
            _driver: "webSQLStorage",
            _initStorage: _initStorage$1,
            _support: isWebSQLValid(),
            iterate: iterate$1,
            getItem: getItem$1,
            setItem: setItem$1,
            removeItem: removeItem$1,
            clear: clear$1,
            length: length$1,
            key: key$1,
            keys: keys$1,
            dropInstance: dropInstance$1
          };
          function isLocalStorageValid() {
            try {
              return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
              !!localStorage.setItem;
            } catch (e) {
              return false;
            }
          }
          function _getKeyPrefix(options, defaultConfig) {
            var keyPrefix = options.name + "/";
            if (options.storeName !== defaultConfig.storeName) {
              keyPrefix += options.storeName + "/";
            }
            return keyPrefix;
          }
          function checkIfLocalStorageThrows() {
            var localStorageTestKey = "_localforage_support_test";
            try {
              localStorage.setItem(localStorageTestKey, true);
              localStorage.removeItem(localStorageTestKey);
              return false;
            } catch (e) {
              return true;
            }
          }
          function _isLocalStorageUsable() {
            return !checkIfLocalStorageThrows() || localStorage.length > 0;
          }
          function _initStorage$2(options) {
            var self2 = this;
            var dbInfo = {};
            if (options) {
              for (var i in options) {
                dbInfo[i] = options[i];
              }
            }
            dbInfo.keyPrefix = _getKeyPrefix(options, self2._defaultConfig);
            if (!_isLocalStorageUsable()) {
              return Promise$1.reject();
            }
            self2._dbInfo = dbInfo;
            dbInfo.serializer = localforageSerializer;
            return Promise$1.resolve();
          }
          function clear$2(callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var keyPrefix = self2._dbInfo.keyPrefix;
              for (var i = localStorage.length - 1; i >= 0; i--) {
                var key2 = localStorage.key(i);
                if (key2.indexOf(keyPrefix) === 0) {
                  localStorage.removeItem(key2);
                }
              }
            });
            executeCallback(promise, callback);
            return promise;
          }
          function getItem$2(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var result = localStorage.getItem(dbInfo.keyPrefix + key2);
              if (result) {
                result = dbInfo.serializer.deserialize(result);
              }
              return result;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate$2(iterator, callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var keyPrefix = dbInfo.keyPrefix;
              var keyPrefixLength = keyPrefix.length;
              var length2 = localStorage.length;
              var iterationNumber = 1;
              for (var i = 0; i < length2; i++) {
                var key2 = localStorage.key(i);
                if (key2.indexOf(keyPrefix) !== 0) {
                  continue;
                }
                var value = localStorage.getItem(key2);
                if (value) {
                  value = dbInfo.serializer.deserialize(value);
                }
                value = iterator(value, key2.substring(keyPrefixLength), iterationNumber++);
                if (value !== void 0) {
                  return value;
                }
              }
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key$2(n, callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var result;
              try {
                result = localStorage.key(n);
              } catch (error) {
                result = null;
              }
              if (result) {
                result = result.substring(dbInfo.keyPrefix.length);
              }
              return result;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys$2(callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var length2 = localStorage.length;
              var keys2 = [];
              for (var i = 0; i < length2; i++) {
                var itemKey = localStorage.key(i);
                if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                  keys2.push(itemKey.substring(dbInfo.keyPrefix.length));
                }
              }
              return keys2;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length$2(callback) {
            var self2 = this;
            var promise = self2.keys().then(function(keys2) {
              return keys2.length;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function removeItem$2(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              localStorage.removeItem(dbInfo.keyPrefix + key2);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem$2(key2, value, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              if (value === void 0) {
                value = null;
              }
              var originalValue = value;
              return new Promise$1(function(resolve, reject) {
                var dbInfo = self2._dbInfo;
                dbInfo.serializer.serialize(value, function(value2, error) {
                  if (error) {
                    reject(error);
                  } else {
                    try {
                      localStorage.setItem(dbInfo.keyPrefix + key2, value2);
                      resolve(originalValue);
                    } catch (e) {
                      if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                        reject(e);
                      }
                      reject(e);
                    }
                  }
                });
              });
            });
            executeCallback(promise, callback);
            return promise;
          }
          function dropInstance$2(options, callback) {
            callback = getCallback.apply(this, arguments);
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              var currentConfig = this.config();
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              promise = new Promise$1(function(resolve) {
                if (!options.storeName) {
                  resolve(options.name + "/");
                } else {
                  resolve(_getKeyPrefix(options, self2._defaultConfig));
                }
              }).then(function(keyPrefix) {
                for (var i = localStorage.length - 1; i >= 0; i--) {
                  var key2 = localStorage.key(i);
                  if (key2.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key2);
                  }
                }
              });
            }
            executeCallback(promise, callback);
            return promise;
          }
          var localStorageWrapper = {
            _driver: "localStorageWrapper",
            _initStorage: _initStorage$2,
            _support: isLocalStorageValid(),
            iterate: iterate$2,
            getItem: getItem$2,
            setItem: setItem$2,
            removeItem: removeItem$2,
            clear: clear$2,
            length: length$2,
            key: key$2,
            keys: keys$2,
            dropInstance: dropInstance$2
          };
          var sameValue = function sameValue2(x, y) {
            return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
          };
          var includes = function includes2(array, searchElement) {
            var len = array.length;
            var i = 0;
            while (i < len) {
              if (sameValue(array[i], searchElement)) {
                return true;
              }
              i++;
            }
            return false;
          };
          var isArray = Array.isArray || function(arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
          };
          var DefinedDrivers = {};
          var DriverSupport = {};
          var DefaultDrivers = {
            INDEXEDDB: asyncStorage,
            WEBSQL: webSQLStorage,
            LOCALSTORAGE: localStorageWrapper
          };
          var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
          var OptionalDriverMethods = ["dropInstance"];
          var LibraryMethods = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(OptionalDriverMethods);
          var DefaultConfig = {
            description: "",
            driver: DefaultDriverOrder.slice(),
            name: "localforage",
            // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
            // we can use without a prompt.
            size: 4980736,
            storeName: "keyvaluepairs",
            version: 1
          };
          function callWhenReady(localForageInstance, libraryMethod) {
            localForageInstance[libraryMethod] = function() {
              var _args = arguments;
              return localForageInstance.ready().then(function() {
                return localForageInstance[libraryMethod].apply(localForageInstance, _args);
              });
            };
          }
          function extend() {
            for (var i = 1; i < arguments.length; i++) {
              var arg = arguments[i];
              if (arg) {
                for (var _key in arg) {
                  if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                      arguments[0][_key] = arg[_key].slice();
                    } else {
                      arguments[0][_key] = arg[_key];
                    }
                  }
                }
              }
            }
            return arguments[0];
          }
          var LocalForage = function() {
            function LocalForage2(options) {
              _classCallCheck(this, LocalForage2);
              for (var driverTypeKey in DefaultDrivers) {
                if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                  var driver = DefaultDrivers[driverTypeKey];
                  var driverName = driver._driver;
                  this[driverTypeKey] = driverName;
                  if (!DefinedDrivers[driverName]) {
                    this.defineDriver(driver);
                  }
                }
              }
              this._defaultConfig = extend({}, DefaultConfig);
              this._config = extend({}, this._defaultConfig, options);
              this._driverSet = null;
              this._initDriver = null;
              this._ready = false;
              this._dbInfo = null;
              this._wrapLibraryMethodsWithReady();
              this.setDriver(this._config.driver)["catch"](function() {
              });
            }
            LocalForage2.prototype.config = function config(options) {
              if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                if (this._ready) {
                  return new Error("Can't call config() after localforage has been used.");
                }
                for (var i in options) {
                  if (i === "storeName") {
                    options[i] = options[i].replace(/\W/g, "_");
                  }
                  if (i === "version" && typeof options[i] !== "number") {
                    return new Error("Database version must be a number.");
                  }
                  this._config[i] = options[i];
                }
                if ("driver" in options && options.driver) {
                  return this.setDriver(this._config.driver);
                }
                return true;
              } else if (typeof options === "string") {
                return this._config[options];
              } else {
                return this._config;
              }
            };
            LocalForage2.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
              var promise = new Promise$1(function(resolve, reject) {
                try {
                  var driverName = driverObject._driver;
                  var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                  if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                  }
                  var driverMethods = LibraryMethods.concat("_initStorage");
                  for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                      reject(complianceError);
                      return;
                    }
                  }
                  var configureMissingMethods = function configureMissingMethods2() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory2(methodName) {
                      return function() {
                        var error = new Error("Method " + methodName + " is not implemented by the current driver");
                        var promise2 = Promise$1.reject(error);
                        executeCallback(promise2, arguments[arguments.length - 1]);
                        return promise2;
                      };
                    };
                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                      var optionalDriverMethod = OptionalDriverMethods[_i];
                      if (!driverObject[optionalDriverMethod]) {
                        driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                      }
                    }
                  };
                  configureMissingMethods();
                  var setDriverSupport = function setDriverSupport2(support) {
                    if (DefinedDrivers[driverName]) {
                      console.info("Redefining LocalForage driver: " + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    resolve();
                  };
                  if ("_support" in driverObject) {
                    if (driverObject._support && typeof driverObject._support === "function") {
                      driverObject._support().then(setDriverSupport, reject);
                    } else {
                      setDriverSupport(!!driverObject._support);
                    }
                  } else {
                    setDriverSupport(true);
                  }
                } catch (e) {
                  reject(e);
                }
              });
              executeTwoCallbacks(promise, callback, errorCallback);
              return promise;
            };
            LocalForage2.prototype.driver = function driver() {
              return this._driver || null;
            };
            LocalForage2.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
              var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
              executeTwoCallbacks(getDriverPromise, callback, errorCallback);
              return getDriverPromise;
            };
            LocalForage2.prototype.getSerializer = function getSerializer(callback) {
              var serializerPromise = Promise$1.resolve(localforageSerializer);
              executeTwoCallbacks(serializerPromise, callback);
              return serializerPromise;
            };
            LocalForage2.prototype.ready = function ready(callback) {
              var self2 = this;
              var promise = self2._driverSet.then(function() {
                if (self2._ready === null) {
                  self2._ready = self2._initDriver();
                }
                return self2._ready;
              });
              executeTwoCallbacks(promise, callback, callback);
              return promise;
            };
            LocalForage2.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
              var self2 = this;
              if (!isArray(drivers)) {
                drivers = [drivers];
              }
              var supportedDrivers = this._getSupportedDrivers(drivers);
              function setDriverToConfig() {
                self2._config.driver = self2.driver();
              }
              function extendSelfWithDriver(driver) {
                self2._extend(driver);
                setDriverToConfig();
                self2._ready = self2._initStorage(self2._config);
                return self2._ready;
              }
              function initDriver(supportedDrivers2) {
                return function() {
                  var currentDriverIndex = 0;
                  function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers2.length) {
                      var driverName = supportedDrivers2[currentDriverIndex];
                      currentDriverIndex++;
                      self2._dbInfo = null;
                      self2._ready = null;
                      return self2.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }
                    setDriverToConfig();
                    var error = new Error("No available storage method found.");
                    self2._driverSet = Promise$1.reject(error);
                    return self2._driverSet;
                  }
                  return driverPromiseLoop();
                };
              }
              var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                return Promise$1.resolve();
              }) : Promise$1.resolve();
              this._driverSet = oldDriverSetDone.then(function() {
                var driverName = supportedDrivers[0];
                self2._dbInfo = null;
                self2._ready = null;
                return self2.getDriver(driverName).then(function(driver) {
                  self2._driver = driver._driver;
                  setDriverToConfig();
                  self2._wrapLibraryMethodsWithReady();
                  self2._initDriver = initDriver(supportedDrivers);
                });
              })["catch"](function() {
                setDriverToConfig();
                var error = new Error("No available storage method found.");
                self2._driverSet = Promise$1.reject(error);
                return self2._driverSet;
              });
              executeTwoCallbacks(this._driverSet, callback, errorCallback);
              return this._driverSet;
            };
            LocalForage2.prototype.supports = function supports(driverName) {
              return !!DriverSupport[driverName];
            };
            LocalForage2.prototype._extend = function _extend(libraryMethodsAndProperties) {
              extend(this, libraryMethodsAndProperties);
            };
            LocalForage2.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
              var supportedDrivers = [];
              for (var i = 0, len = drivers.length; i < len; i++) {
                var driverName = drivers[i];
                if (this.supports(driverName)) {
                  supportedDrivers.push(driverName);
                }
              }
              return supportedDrivers;
            };
            LocalForage2.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
              for (var i = 0, len = LibraryMethods.length; i < len; i++) {
                callWhenReady(this, LibraryMethods[i]);
              }
            };
            LocalForage2.prototype.createInstance = function createInstance(options) {
              return new LocalForage2(options);
            };
            return LocalForage2;
          }();
          var localforage_js = new LocalForage();
          module3.exports = localforage_js;
        }, { "3": 3 }] }, {}, [4])(4);
      });
    }
  });

  // node_modules/zenscroll/zenscroll.js
  var require_zenscroll = __commonJS({
    "node_modules/zenscroll/zenscroll.js"(exports, module) {
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define([], factory());
        } else if (typeof module === "object" && module.exports) {
          module.exports = factory();
        } else {
          (function install() {
            if (document && document.body) {
              root.zenscroll = factory();
            } else {
              setTimeout(install, 9);
            }
          })();
        }
      })(exports, function() {
        "use strict";
        var isNativeSmoothScrollEnabledOn = function(elem) {
          return elem && "getComputedStyle" in window && window.getComputedStyle(elem)["scroll-behavior"] === "smooth";
        };
        if (typeof window === "undefined" || !("document" in window)) {
          return {};
        }
        var makeScroller = function(container, defaultDuration, edgeOffset) {
          defaultDuration = defaultDuration || 999;
          if (!edgeOffset && edgeOffset !== 0) {
            edgeOffset = 9;
          }
          var scrollTimeoutId;
          var setScrollTimeoutId = function(newValue) {
            scrollTimeoutId = newValue;
          };
          var stopScroll = function() {
            clearTimeout(scrollTimeoutId);
            setScrollTimeoutId(0);
          };
          var getTopWithEdgeOffset = function(elem) {
            return Math.max(0, container.getTopOf(elem) - edgeOffset);
          };
          var scrollToY = function(targetY, duration, onDone) {
            stopScroll();
            if (duration === 0 || duration && duration < 0 || isNativeSmoothScrollEnabledOn(container.body)) {
              container.toY(targetY);
              if (onDone) {
                onDone();
              }
            } else {
              var startY = container.getY();
              var distance = Math.max(0, targetY) - startY;
              var startTime = (/* @__PURE__ */ new Date()).getTime();
              duration = duration || Math.min(Math.abs(distance), defaultDuration);
              (function loopScroll() {
                setScrollTimeoutId(setTimeout(function() {
                  var p = Math.min(1, ((/* @__PURE__ */ new Date()).getTime() - startTime) / duration);
                  var y = Math.max(0, Math.floor(startY + distance * (p < 0.5 ? 2 * p * p : p * (4 - p * 2) - 1)));
                  container.toY(y);
                  if (p < 1 && container.getHeight() + y < container.body.scrollHeight) {
                    loopScroll();
                  } else {
                    setTimeout(stopScroll, 99);
                    if (onDone) {
                      onDone();
                    }
                  }
                }, 9));
              })();
            }
          };
          var scrollToElem = function(elem, duration, onDone) {
            scrollToY(getTopWithEdgeOffset(elem), duration, onDone);
          };
          var scrollIntoView = function(elem, duration, onDone) {
            var elemHeight = elem.getBoundingClientRect().height;
            var elemBottom = container.getTopOf(elem) + elemHeight;
            var containerHeight = container.getHeight();
            var y = container.getY();
            var containerBottom = y + containerHeight;
            if (getTopWithEdgeOffset(elem) < y || elemHeight + edgeOffset > containerHeight) {
              scrollToElem(elem, duration, onDone);
            } else if (elemBottom + edgeOffset > containerBottom) {
              scrollToY(elemBottom - containerHeight + edgeOffset, duration, onDone);
            } else if (onDone) {
              onDone();
            }
          };
          var scrollToCenterOf = function(elem, duration, offset, onDone) {
            scrollToY(Math.max(0, container.getTopOf(elem) - container.getHeight() / 2 + (offset || elem.getBoundingClientRect().height / 2)), duration, onDone);
          };
          var setup = function(newDefaultDuration, newEdgeOffset) {
            if (newDefaultDuration === 0 || newDefaultDuration) {
              defaultDuration = newDefaultDuration;
            }
            if (newEdgeOffset === 0 || newEdgeOffset) {
              edgeOffset = newEdgeOffset;
            }
            return {
              defaultDuration,
              edgeOffset
            };
          };
          return {
            setup,
            to: scrollToElem,
            toY: scrollToY,
            intoView: scrollIntoView,
            center: scrollToCenterOf,
            stop: stopScroll,
            moving: function() {
              return !!scrollTimeoutId;
            },
            getY: container.getY,
            getTopOf: container.getTopOf
          };
        };
        var docElem = document.documentElement;
        var getDocY = function() {
          return window.scrollY || docElem.scrollTop;
        };
        var zenscroll2 = makeScroller({
          body: document.scrollingElement || document.body,
          toY: function(y) {
            window.scrollTo(0, y);
          },
          getY: getDocY,
          getHeight: function() {
            return window.innerHeight || docElem.clientHeight;
          },
          getTopOf: function(elem) {
            return elem.getBoundingClientRect().top + getDocY() - docElem.offsetTop;
          }
        });
        zenscroll2.createScroller = function(scrollContainer, defaultDuration, edgeOffset) {
          return makeScroller({
            body: scrollContainer,
            toY: function(y) {
              scrollContainer.scrollTop = y;
            },
            getY: function() {
              return scrollContainer.scrollTop;
            },
            getHeight: function() {
              return Math.min(scrollContainer.clientHeight, window.innerHeight || docElem.clientHeight);
            },
            getTopOf: function(elem) {
              return elem.offsetTop;
            }
          }, defaultDuration, edgeOffset);
        };
        if ("addEventListener" in window && !window.noZensmooth && !isNativeSmoothScrollEnabledOn(document.body)) {
          var isHistorySupported = "history" in window && "pushState" in history;
          var isScrollRestorationSupported = isHistorySupported && "scrollRestoration" in history;
          if (isScrollRestorationSupported) {
            history.scrollRestoration = "auto";
          }
          window.addEventListener("load", function() {
            if (isScrollRestorationSupported) {
              setTimeout(function() {
                history.scrollRestoration = "manual";
              }, 9);
              window.addEventListener("popstate", function(event) {
                if (event.state && "zenscrollY" in event.state) {
                  zenscroll2.toY(event.state.zenscrollY);
                }
              }, false);
            }
            if (window.location.hash) {
              setTimeout(function() {
                var edgeOffset = zenscroll2.setup().edgeOffset;
                if (edgeOffset) {
                  var targetElem = document.getElementById(window.location.href.split("#")[1]);
                  if (targetElem) {
                    var targetY = Math.max(0, zenscroll2.getTopOf(targetElem) - edgeOffset);
                    var diff = zenscroll2.getY() - targetY;
                    if (0 <= diff && diff < 9) {
                      window.scrollTo(0, targetY);
                    }
                  }
                }
              }, 9);
            }
          }, false);
          var RE_noZensmooth = new RegExp("(^|\\s)noZensmooth(\\s|$)");
          window.addEventListener("click", function(event) {
            var anchor = event.target;
            while (anchor && anchor.tagName !== "A") {
              anchor = anchor.parentNode;
            }
            if (!anchor || event.which !== 1 || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
              return;
            }
            if (isScrollRestorationSupported) {
              var historyState = history.state && typeof history.state === "object" ? history.state : {};
              historyState.zenscrollY = zenscroll2.getY();
              try {
                history.replaceState(historyState, "");
              } catch (e) {
              }
            }
            var href = anchor.getAttribute("href") || "";
            if (href.indexOf("#") === 0 && !RE_noZensmooth.test(anchor.className)) {
              var targetY = 0;
              var targetElem = document.getElementById(href.substring(1));
              if (href !== "#") {
                if (!targetElem) {
                  return;
                }
                targetY = zenscroll2.getTopOf(targetElem);
              }
              event.preventDefault();
              var onDone = function() {
                window.location = href;
              };
              var edgeOffset = zenscroll2.setup().edgeOffset;
              if (edgeOffset) {
                targetY = Math.max(0, targetY - edgeOffset);
                if (isHistorySupported) {
                  onDone = function() {
                    history.pushState({}, "", href);
                  };
                }
              }
              zenscroll2.toY(targetY, null, onDone);
            }
          }, false);
        }
        return zenscroll2;
      });
    }
  });

  // app/scripts/common/function/loadTemplate.js
  function loadTemplate(elm) {
    const node = elm.closest(".js-tload");
    const template = document.querySelector(node.dataset.tload);
    if (!template)
      return;
    return new Promise((resolve, reject) => {
      template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
        template.insertAdjacentElement("beforebegin", child);
      });
      if (template.tagName == "NOSCRIPT") {
        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(template.innerHTML, "text/html");
        const div = parsedHTML.documentElement;
        console.log(div);
        template.insertAdjacentElement("beforebegin", div);
      }
      node.classList.remove("js-tload");
      node.removeAttribute("data-tload");
      setTimeout(() => {
        resolve(true);
      }, 100);
    });
  }

  // app/scripts/common/function/addEvent.js
  function addEvent(evt, selector, handler) {
    evt.split(" ").forEach((event) => {
      document.addEventListener(event, function(event2) {
        if (event2.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event2.target.closest(selector), arguments);
        }
      }, false);
    });
  }

  // app/scripts/common/function/debounceTime.js
  function debounceTime(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // app/scripts/common/function/serializeForm.js
  function serializeForm(form) {
    const obj = {};
    const formData = new FormData(form);
    let properties = {};
    let hasProperties = false;
    for (const key of formData.keys()) {
      if (key.includes("properties")) {
        if (formData.get(key).length) {
          let newKey = key.slice(0, key.length - 1);
          newKey = newKey.replace("properties[", "");
          properties = Object.assign(properties, {
            [newKey]: formData.get(key)
          });
          hasProperties = true;
        }
      } else {
        obj[key] = formData.get(key);
      }
    }
    if (hasProperties)
      obj.properties = properties;
    return JSON.stringify(obj);
  }

  // app/scripts/common/function/storage.js
  var import_localforage = __toESM(require_localforage(), 1);
  function storage(storageKey) {
    const key = storageKey;
    const storage2 = {
      get: async () => {
        const data = await import_localforage.default.getItem(key);
        if (!data) {
          return data;
        }
        const { expire, value } = data;
        if (expire < Date.now()) {
          import_localforage.default.removeItem(key);
          return null;
        }
        return value;
      },
      set: (value, expire = false) => {
        if (expire) {
          const dataExpired = (/* @__PURE__ */ new Date()).getTime() + 24 * 60 * 60 * expire;
          return import_localforage.default.setItem(key, { value, expire: dataExpired });
        }
        return import_localforage.default.setItem(key, { value });
      }
    };
    return storage2;
  }
  function localStorage2(storageKey, defaultValue = []) {
    const key = storageKey;
    const storage2 = {
      get: () => {
        const data = window.localStorage.getItem(key);
        if (data) {
          return data.split(",");
        }
        return defaultValue;
      },
      set: (value, expire = false) => {
        if (expire) {
          const dataExpired = (/* @__PURE__ */ new Date()).getTime() + 24 * 60 * 60 * expire;
          return window.localStorage.setItem(key, { value, expire: dataExpired });
        }
        storage2.dispatchEvent();
        console.log("in set", value);
        return window.localStorage.setItem(key, value);
      },
      clear: () => {
        window.localStorage.removeItem(key);
        storage2.dispatchEvent();
      },
      dispatchEvent: () => {
        window.dispatchEvent(new CustomEvent(`localStorage:${key}:change`, {
          bubbles: true,
          detail: {}
        }));
      }
    };
    return storage2;
  }
  function sessionStorage(storageKey) {
    const key = storageKey;
    const sessionStore = window.sessionStorage;
    const storage2 = {
      get: () => {
        const data = sessionStore.getItem(key) || null;
        return data;
      },
      set: (value) => {
        return sessionStore.setItem(key, value);
      },
      clearAll: () => {
        sessionStore.removeItem(key);
      }
    };
    return storage2;
  }

  // app/scripts/common/index.js
  window.theme = Object.assign(window.theme || {}, {
    addEvent,
    serializeForm,
    debounceTime,
    loadTemplate,
    localStorage: localStorage2,
    sessionStorage,
    toggleSticky: function(hide = true) {
      if (hide) {
        document.querySelector("sticky-header")?.classList.add("tnone");
        return;
      }
      document.querySelector("sticky-header")?.classList.remove("tnone");
    },
    inViewPort(el, callback, once = null) {
      const observer = new IntersectionObserver((entries, observer2) => {
        callback(entries[0].isIntersecting);
        if (entries[0].isIntersecting) {
          once && observer2.disconnect();
        }
      });
      observer.observe(el);
    }
  });

  // app/scripts/common/events/calculateScrollBarWidth.js
  function scrollBarWidth() {
    let t = document.body.getBoundingClientRect();
    if (t.left + t.right < window.innerWidth)
      return window.innerWidth - (t.left + t.right);
    return 0;
  }
  document.documentElement.style.setProperty("--scrollbar-width", scrollBarWidth() + "px");
  window.addEventListener("resize", () => {
    document.documentElement.style.setProperty("--scrollbar-width", scrollBarWidth() + "px");
  });

  // app/scripts/common/events/toggleClass.js
  var { addEvent: addEvent2 } = theme;
  addEvent2("click", ".jsToggleClass", (e) => {
    const el = e.target.closest(".jsToggleClass");
    const target = document.querySelectorAll(el.dataset.target || null);
    if (!target.length)
      return;
    let { className, classRemove, classRule, classEvent } = el.dataset;
    if (!className) {
      className = "active";
    }
    if (classEvent == "none") {
      e.preventDefault();
      e.stopPropagation();
    }
    target.forEach((i) => {
      switch (classRule) {
        case "add":
          i.classList.add(...className.split(","));
          break;
        case "remove":
          i.classList.remove(...className.split(","));
          break;
        default:
          className.split(",").forEach((c) => i.classList.toggle(c));
          break;
      }
      if (classRemove) {
        i.classList.remove(...classRemove.split(","));
      }
      i.className.includes("header-search") && document.querySelector("header predictive-search")?.focusSearch();
    });
  });

  // app/scripts/common/events/togglePopup.js
  var { addEvent: addEvent3, loadTemplate: loadTemplate2 } = theme;
  addEvent3("click", ".js-popup-toggle", async (e) => {
    const el = e.target.closest(".js-popup-toggle");
    if (el.classList.contains("js-tload")) {
      await loadTemplate2(el);
    }
    const popup = document.querySelector(el.dataset.control);
    if (!popup)
      return;
    popup.tagName.toLowerCase().includes("popup") && popup.toggle((resp) => {
      el.classList.toggle("active", resp?.isActive || false);
    });
  });

  // app/scripts/common/events/loadTemplate.js
  var { addEvent: addEvent4 } = theme;
  addEvent4("click", ".js-tload", (e) => {
    const node = e.target.closest(".js-tload");
    const template = document.querySelector(node.dataset.tload);
    e.preventDefault();
    e.stopPropagation();
    template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
      template.insertAdjacentElement("beforebegin", child);
    });
    if (template.tagName == "NOSCRIPT") {
      const div = document.createElement("div");
      div.innerHTML = template.innerHTML;
      template.insertAdjacentElement("beforebegin", div);
    }
    template.remove();
    node.classList.remove("js-tload");
    node.removeAttribute("data-tload");
    theme.actionQueue && theme.actionQueue.length && setTimeout(() => {
      theme.actionQueue.forEach((i, index) => {
        i.el.dispatchEvent(new Event(i.event));
        i.event == "click" && i.el.click();
        theme.actionQueue.splice(index, 1);
      });
    }, 300);
  });

  // app/scripts/common/events/keyEvents.js
  document.addEventListener("keyup", (e) => {
    e.key == `Escape` && document.querySelectorAll("details[open]")?.forEach((item) => item.removeAttribute("open"));
  });

  // app/scripts/common/function/scroll.js
  var import_zenscroll = __toESM(require_zenscroll(), 1);
  function Scroll(selector, duration, offset, callback = null) {
    var duration = duration || 500;
    var offset = offset || 0;
    const headerSticky = document.querySelector("sticky-header")?.getBoundingClientRect().bottom || 0;
    headerSticky > 0 && (offset = offset - headerSticky);
    const top = selector.offsetTop + offset;
    import_zenscroll.default.toY(top, duration, callback);
  }

  // app/scripts/common/events/clickToScroll.js
  var { addEvent: addEvent5 } = theme;
  addEvent5("click", ".js-scroll-to", (e) => {
    const el = e.target.closest(".js-scroll-to");
    const selector = el.dataset.scroll || null;
    const target = document.querySelector(selector);
    if (!target || !selector)
      return;
    e.preventDefault();
    e.stopPropagation();
    const duration = +el.dataset.duration || null;
    const offset = document.querySelector(".product-sticky-desktop")?.scrollHeight || 0;
    Scroll(target, duration, offset * -1);
  });

  // app/scripts/common/function/cart.js
  window.cartForm = class extends HTMLElement {
    constructor() {
      super();
      this.sectionName = this.dataset.section || "cart-section";
      if (theme.routes.pageType == "cart") {
        this.sectionName = "main-cart-page";
      }
      this.sections = [
        {
          key: "count",
          section: "cart-live-region-text"
        },
        {
          key: "noti",
          section: "cart-noti"
        },
        {
          key: "section",
          section: this.sectionName
        }
      ];
      window.addEventListener("cart:refresh", this.cartRefresh.bind(this));
    }
    getHeader(formData) {
      if (!(formData instanceof FormData)) {
        return { "Content-Type": "application/json;" };
      } else
        return { "X-Requested-With": "XMLHttpRequest" };
    }
    sectionList(section) {
      if (section) {
        const callSection = section.split(",");
        return this.sections.filter((i) => callSection.includes(i.key)).map((i) => i.section).join(",");
      }
      return this.sections.map((i) => i.section).join(",");
    }
    async cartAdd(formData) {
      let response = await fetch(`${theme.routes.cartUrl}/add.js`, {
        method: "POST",
        headers: this.getHeader(formData),
        body: formData
      });
      response = await response.json();
      this.currentState = "add";
      if (response.status) {
        console.error(response);
        this.notify = response.description || response.message;
        this.cartRefresh({ isSuccess: false, sections: null });
        return;
      }
      this.cartRefresh({ isSuccess: true, sections: response.sections });
      this.response = response;
      return true;
    }
    async cartChange(formData) {
      const response = await this.callCartChange(formData);
      this.currentState = "change";
      if (response.status) {
        console.error(response);
        this.notify = response.description || response.message;
        this.cartRefresh({ isSuccess: false, sections: null });
        return;
      }
      this.response = response;
      this.cartRefresh({ isSuccess: true, sections: response.sections });
    }
    async cartUpdate(formData) {
      let response = await this.callCartUpdate({ attributes: formData });
      this.currentState = "update";
      this.onFinished();
    }
    async callCartChange(formData) {
      let response = await fetch(`${theme.routes.cartUrl}/change.js`, {
        method: "POST",
        headers: this.getHeader(formData),
        body: JSON.stringify(formData)
      });
      return await response.json();
    }
    async callCartUpdate(body) {
      let response = await fetch(`${theme.routes.cartUrl}/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;"
        },
        body: JSON.stringify(body)
      });
      return await response.json();
    }
    async cartRefresh(resp) {
      let response = resp;
      let sections = response.sections;
      if (sections) {
        this.successNotify = sections;
      } else {
        let newResp = await fetch(`${theme.routes.cartUrl}?sections=${this.sectionList()}`);
        sections = await newResp.json();
      }
      this.updateCartCount = sections[this.sectionList("count")].split("<!-- split -->")[1];
      response.sections = sections;
      this.onUpdating(response);
    }
    async onChange(event) {
      let target = event.target;
      let quantity;
      if (event.detail) {
        target = event.detail.customElement.target;
        quantity = 0;
      } else {
        quantity = +target.value;
      }
      let { key, sections: targetSection, sections_url, giftKey } = target.dataset;
      if (!key)
        return;
      let sections = this.sections.map((i) => i.section);
      sections.push(targetSection);
      sections = Array.from(new Set(sections));
      this.currentline = target.closest(".jsLineItem");
      this.body = {
        id: key,
        quantity,
        sections,
        sections_url
      };
      target.replaceWith(document.querySelector("#svg_loading > svg")?.cloneNode(true));
      if (giftKey) {
        this.giftHandle(key, giftKey, quantity);
      } else {
        this.cartChange(this.body);
      }
    }
    async giftHandle(currentLine, giftLine, qty) {
      const giftLineItem = this.querySelector(`.jsLineItem:nth-child(${giftLine})`);
      if (giftLineItem) {
        const giftKey = giftLineItem.dataset.key;
        let response = await this.callCartUpdate({
          updates: {
            [currentLine]: qty,
            [giftKey]: qty
          }
        });
      } else {
        let response = await this.callCartUpdate({
          updates: {
            [currentLine]: qty
          }
        });
      }
      this.cartRefresh({ isSuccess: true, sections: null });
    }
    onUpdating(response) {
      try {
        const section = response.sections[this.sectionName];
        if (section) {
          let div = document.createElement("div");
          div.innerHTML = section;
          if (this.cartCount > 0) {
            if (!this.body.quantity) {
              this.innerHTML = div.querySelector(`${this.tagName}`).innerHTML;
            } else {
              const allNewLines = div.querySelectorAll(`.jsLineItem`);
              [...allNewLines].every((newLine) => {
                const { key } = newLine.dataset;
                const currentLine = this.querySelector(`[data-key="${key}"]`);
                if (currentLine) {
                  currentLine.querySelectorAll(".jsLineUpdate").forEach((updateLine) => {
                    const component = newLine.querySelector(`[class="${updateLine.className}"]`);
                    if (!component)
                      return;
                    updateLine.innerHTML = component.innerHTML;
                  });
                  return true;
                } else {
                  this.innerHTML = div.querySelector(`${this.tagName}`).innerHTML;
                  return false;
                }
              });
            }
            this.querySelectorAll(".jsCartUpdate").forEach((item) => {
              item.innerHTML = div.querySelector(`[class="${item.className}"]`).innerHTML;
            });
          } else {
            this.innerHTML = div.querySelector(`${this.tagName}`).innerHTML;
          }
        }
        this.onFinished(response);
      } catch (e) {
        console.log(e);
      }
    }
    onFinished() {
      this.response = null;
    }
    set notify(msg) {
      (async () => {
        let response = await fetch(`${theme.routes.searchUrl}?q=${msg}&section_id=${this.sectionList("noti")}`);
        response = await response.text();
        let div = document.createElement("div");
        div.innerHTML = response;
        Array.from(div.querySelector(".shopify-section").children).forEach((el) => {
          document.body.insertAdjacentElement("beforeend", el);
        });
      })();
    }
    get getSubmitButton() {
      return Array.from(this.form.elements).filter((button) => button.type === "submit");
    }
    set loadingState(bool) {
      const buttons = this.getSubmitButton;
      if (bool) {
        buttons.forEach((button) => {
          button.setAttribute("aria-busy", true);
          button.classList.add("disabled");
          button.HTMLTemp = button.innerHTML;
          button.innerHTML = document.querySelector("#svg_loading").innerHTML;
        });
      } else {
        buttons.forEach((button) => {
          button.removeAttribute("aria-busy");
          button.classList.remove("disabled");
          button.innerHTML = button.HTMLTemp;
          button.HTMLTemp = null;
        });
      }
    }
    set successNotify(sections = []) {
      const html = sections[this.sectionList("noti")];
      if (!html)
        return;
      let div = document.createElement("div");
      div.innerHTML = html;
      Array.from(div.querySelector(".shopify-section").children).forEach((el) => {
        document.body.insertAdjacentElement("beforeend", el);
        const isPopup = el.tagName.toLowerCase().includes("popup");
      });
    }
    set updateCartCount(value) {
      this.cartCount = value;
      document.querySelectorAll(".jsCartCount")?.forEach((item) => {
        if (item.classList.contains("drawer")) {
          if (value == 1) {
            value = value + " item";
          } else {
            value = value + " items";
          }
          item.setAttribute("data-count", value);
        } else {
          item.setAttribute("data-count", value);
        }
      });
    }
  };

  // app/scripts/common/function/recentlyViewed.js
  var { routes: { pageType }, product } = theme;
  (async () => {
    const saver = storage("recently-viewed");
    let result = await saver.get() || [];
    if (pageType == "product") {
      let findExist = result.find((item) => item.handle == product.handle);
      if (findExist) {
        result = result.filter((item) => item.handle != product.handle);
      }
      result.push({
        handle: product.handle,
        expired: (/* @__PURE__ */ new Date()).getTime()
      });
      saver.set(result);
    }
    customElements.define("recently-viewed", class recentlyViewed extends HTMLElement {
      connectedCallback() {
        this.arrObject = result.reverse();
        if (this.arrObject.length > +this.dataset.limit)
          this.arrObject.length = +this.dataset.limit;
        this.arrObject = this.arrObject.reverse();
        const promiseArr = [];
        this.arrObject.length && this.arrObject.forEach((obj) => {
          if (pageType == "product" && obj.handle == product.handle)
            return;
          promiseArr.push(this.getProduct(obj.handle));
        });
        Promise.all(promiseArr).then((html) => {
          this.render = html.join(" ");
        });
      }
      getProduct(handle) {
        return new Promise((resolved, rejected) => {
          const productUrl = `products/${handle}?`;
          fetch(this.dataset.url.replace("?", productUrl)).then((e) => e.text()).then((e) => resolved(e.split("<!-- split -->")[1]));
        });
      }
      set render(value) {
        this.querySelector(".jsContainer").innerHTML = value;
        this.classList.remove("none");
        this.querySelector(".jsSlideEl")?.load();
        saver.set(this.arrObject);
      }
    });
  })();

  // app/scripts/common/function/wishlistLoop.js
  var requestAnimationFrame2 = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  var last = 0;
  var wlcpLoop = () => {
    const now = (/* @__PURE__ */ new Date()).getTime();
    if (!last || now - last >= 1e3) {
      last = now;
      document.querySelectorAll(".js-wl-count, .js-cp-count")?.forEach((item) => {
        const count = item.textContent.trim() || "0";
        item.setAttribute("data-count", count);
      });
      document.querySelectorAll(`.js-compare-btn.added`)?.forEach((i) => {
        i.classList.remove("added");
      });
      theme.compareList?.forEach((handle) => {
        document.querySelectorAll(`.js-compare-btn[data-handle="${handle}"]`)?.forEach((i) => {
          i.classList.add("added");
        });
      });
    }
    requestAnimationFrame2(wlcpLoop);
  };
  wlcpLoop();

  // app/scripts/common/component/details.js
  var Accordion = class {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector(":scope > summary");
      this.close = el.querySelector(".js-details-close");
      this.content = el.querySelector(":scope > *:not(summary)");
      this.wrapper = el.closest(".jsAccordionWrapper");
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener("click", (e) => this.onClick(e));
      if (this.close) {
        this.close.closest("details") == this.el && this.close.addEventListener("click", (e) => this.onClick(e));
      }
      this.el.classList.add("accordion-initialized");
    }
    onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.el.style.overflow = "hidden";
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.el.classList.add("is-closing");
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      this.el.classList.add("is-opening");
      window.requestAnimationFrame(() => this.expand());
    }
    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = "";
      this.el.classList.remove("is-closing", "is-opening");
      this.wrapper?.classList.toggle("accordion-showing", open);
    }
  };
  var selectors = {
    activeList: document.querySelectorAll("details[open]:not(.noJS)")
  };
  document.addEventListener("click", (e) => {
    if (!selectors.activeList.length)
      return;
    !e.target.closest("details") && selectors.activeList.forEach((j) => {
      if (j.closest(".accordion-initialized"))
        return;
      j.open = false;
    });
  });
  window.customElements.define("accordion-component", class extends HTMLElement {
    constructor() {
      super();
      if (this.hasAttribute("data-open-screen") || this.hasAttribute("data-close-screen")) {
        const { debounceTime: debounceTime2 } = theme;
        const debounce = debounceTime2((e) => this.changeState(e), 300);
        window.addEventListener("resize", debounce.bind(this));
      }
      this.querySelectorAll("summary a").forEach((link) => {
        link.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });
    }
    connectedCallback() {
      this.Accordion = new Accordion(this.querySelector("details"));
      this.changeState();
    }
    changeState() {
      this.hasAttribute("data-open-screen") && window.matchMedia(this.getAttribute("data-open-screen")).matches && (this.querySelector("details").open = true);
      this.hasAttribute("data-close-screen") && window.matchMedia(this.getAttribute("data-close-screen")).matches && (this.querySelector("details").open = false);
    }
  });

  // app/scripts/common/function/currencies.js
  var multiCurrency = {};
  multiCurrency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
      money_format: "{{amount}} \u043B\u0432",
      money_with_currency_format: "{{amount}} \u043B\u0432 BGN"
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
      money_format: "\u043B\u0432{{amount}}",
      money_with_currency_format: "\u043B\u0432{{amount}}"
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
      money_format: "\u0434\u0435\u043D {{amount}}",
      money_with_currency_format: "\u0434\u0435\u043D {{amount}} MKD"
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
      money_format: "SFr. {{amount}}",
      money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
      money_format: "\u20B4{{amount}}",
      money_with_currency_format: "\u20B4{{amount}} UAH"
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  };
  multiCurrency.formatMoney = function(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  var currencies_default = multiCurrency;

  // app/scripts/common/component/priceComponent.js
  var moneyElement = class extends HTMLElement {
    constructor() {
      super();
      this.value = +this.dataset.value;
      this.content = this.lastElementChild || this;
    }
    get() {
      return this.value;
    }
    set(value) {
      this.value = value;
      if (!this.classList.contains("jsRequiredValue") && value == 0) {
        this.content.innerHTML = "";
        return;
      }
      let currencyFormat = this.dataset.format || theme.settings.currencyFormat || "money_format";
      let f = currencies_default.moneyFormats[theme.settings.currency][currencyFormat] || "{{amount}}";
      this.content.innerHTML = currencies_default.formatMoney(value, f);
    }
  };
  customElements.define("price-component", moneyElement);

  // app/scripts/common/component/popupComponent.js
  customElements.define("popup-component", class extends HTMLElement {
    connectedCallback() {
      let className = this.dataset.className?.split(",") || [];
      className.push("active");
      const bodyClass = this.dataset.bodyClass || "show-popup";
      this.classes = {
        className,
        bodyClass
      };
      this.addEventListener("click", ({ target: currentTarget }) => {
        if (!currentTarget.closest(".popup__content") && !currentTarget.closest(".jsContent") || currentTarget.closest(".jsClose"))
          this.close();
      });
      this.appendDocument();
      this.autoShow();
    }
    close() {
      this.classList.remove(...this.classes.className);
      this.setAttribute("aria-hidden", true);
      if (!document.querySelectorAll('popup-component:not([aria-hidden="true"])').length)
        document.body.classList.remove(this.classes.bodyClass);
      this.isActive = false;
    }
    open(callback = null) {
      this.classList.add(...this.classes.className);
      this.setAttribute("aria-hidden", false);
      this.autoHide();
      document.body.classList.add(this.classes.bodyClass);
      this.isActive = true;
      setTimeout(() => this.focus(), 100);
      callback && callback();
    }
    toggle(callback = null) {
      this.isActive ? this.close() : this.open();
      callback && callback(this.isActive);
    }
    appendDocument() {
      if (!this.hasAttribute("append-body"))
        return;
      this.removeAttribute("append-body");
      const existingNode = document.getElementById(this.id);
      if (existingNode && existingNode !== this) {
        existingNode.after(this);
        existingNode.remove();
      }
    }
    autoShow() {
      if (!this.hasAttribute("append-auto"))
        return;
      this.removeAttribute("append-auto");
      setTimeout(() => {
        this.open();
      }, 300);
    }
    autoHide() {
      if (!this.hasAttribute("auto-hide"))
        return;
      if (this.isHiding != null)
        clearTimeout(this.isHiding);
      this.isHiding = setTimeout(() => {
        this.close();
        this.isHiding = null;
      }, +this.getAttribute("auto-hide"));
    }
  });

  // app/scripts/common/component/quantity.js
  customElements.define("quantity-input", class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.changeEvent = new Event("change", { bubbles: true });
      this.input = this.querySelector("input");
      if (this.input) {
        this.querySelectorAll("button")?.forEach((button) => {
          button.addEventListener("click", this.onButtonClick.bind(this));
        });
        this.input.addEventListener("change", () => {
          this.classList.toggle("is-max-reached", +this.input.value >= +this.input.max);
        });
      } else {
        this.querySelector("select")?.addEventListener("change", (e) => {
          this.dispatchEvent(this.changeEvent);
        });
      }
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }
  });

  // app/scripts/common/component/productCard.js
  customElements.define("product-card", class extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll(".jsPopupBtn").forEach((item) => {
        item.addEventListener("click", () => {
          this.onFetchQuickShop(item);
        });
      });
    }
    async onFetchQuickShop(button) {
      const url = button.dataset.popupUrl;
      document.body.classList.add("event-none");
      let result = await fetch(url);
      result = await result.text();
      result = result.split("<!-- split -->")[1];
      document.body.insertAdjacentHTML("beforeend", result);
      document.body.classList.remove("event-none");
    }
  });
  customElements.define("product-cart-form", class productCartForm extends cartForm {
    constructor() {
      super();
      this.form = this.querySelector(`form[id="${this.dataset.formId}"]`);
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submitForm();
      });
    }
    async submitForm() {
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }
      this.loadingState = true;

      const giftModel = document.querySelector('.gift-model-main');
      if (giftModel) {
        setTimeout(() => {
          giftModel.classList.remove('model-open');
        }, 2300);
      }

      const productStickyMobile = document.querySelector('.product-sticky-mobile');
      if (productStickyMobile) {
        productStickyMobile.classList.remove('active');
      }
      
      const formData = new FormData(this.form);
      formData.append("sections", this.sectionList());
      formData.append("sections_url", this.dataset.url || location.pathname);
      const giftEls = this.querySelectorAll("gift-product-component");
      
      if (giftEls.length == 1) {
        let index = 1;
        for (const giftEl of giftEls) {
          giftEl.setQuantity = Math.max(+formData.get("quantity"), 1);
          giftEl.setProperty = formData.get("id");
          await giftEl.submit();
          const propName = `_GiftKey` + index;
          formData.append(`properties[${propName}]`, giftEl.getReponse.key);
          index++;
        }
      }
      else if (giftEls.length > 1) {
        const selectedRadio = this.querySelector('input[type="radio"][name="gift_item"]:checked');
        if (!selectedRadio) {
          alert("Please select a gift item before adding to the cart.");
          this.loadingState = false;
          return;
        }

        const selectedProductId = selectedRadio.value;
        const giftEl = this.querySelector(`gift-product-component[data-id="${selectedProductId}"]`);
        
        if (giftEl) {
          giftEl.setQuantity = Math.max(+formData.get("quantity"), 1);
          giftEl.setProperty = formData.get("id");
          await giftEl.submit();            
          const propName = `_GiftKey1`;
          formData.append(`properties[${propName}]`, giftEl.getReponse.key);
        }        
      }      

      await this.cartAdd(formData);
      this.loadingState = false;

    }
    onUpdating(response) {
      if (!response.isSuccess)
        return;
      if (this.closest("gift-product-component")) {
        return;
      }
      ["cart-drawer-component", "cart-component"].forEach((section) => {
        const sectionEl = document.querySelector(section);
        if (sectionEl) {
          sectionEl.refresh = response.sections;
          sectionEl.open = true;
        }
      });
    }
  });
  window.customElements.define("gift-product-component", class extends HTMLElement {
    async submit() {
      await this.querySelector("product-cart-form").submitForm();
    }
    set setQuantity(value) {
      this.querySelector('[name="quantity"]').value = value;
    }
    set setProperty(value) {
      this.querySelector('[name="properties[_GiftFrom]"]')?.remove();
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_GiftFrom]";
      input.value = value;
      this.querySelector('form[action*="cart"]').insertAdjacentElement("beforeend", input);
    }
    get getReponse() {
      return this.querySelector("product-cart-form").response;
    }
  });

  // app/scripts/common/component/productItemForm.js
  var { inViewPort, addEvent: addEvent6 } = theme;
  customElements.define("product-item-form", class productItemForm extends HTMLElement {
    connectedCallback() {
      let productData = this.querySelector('script[type="application/json"]')?.innerHTML;
      if (productData) {
        this.productData = JSON.parse(productData);
      }
      this.JSON = this.productData;
      this.linkOptions();
      this.addEventListener("change", this.onChange.bind(this));
      this.template = this.querySelector("#variantTemplate")?.content || null;
    }
    onChange(event) {
      const target = event.target;
      if (!target.classList.contains("js-variant-change"))
        return;
      let index = +target.name.replace(/[^\d]/g, "");
      if (index == 1) {
        this.updateOptionsInSelector(2);
        this.updateOptionsInSelector(3);
      }
      if (index == 2) {
        this.updateOptionsInSelector(3);
      }
      if (!this.getVariant())
        return;
      if (this.currentVariant) {
        this.updateId();
        this.updateContent();
      } else {
        this.setUnavailable();
      }
      this.closest("[data-section-id]").classList.toggle("variant-soldout", !this.currentVariant?.available || false);
      const { swatchId } = target.dataset;
      this.querySelector(swatchId)?.classList.remove("active");
    }
    updateId() {
      if (this.currentVariant && this.currentVariant.available) {
        const masterID = this.querySelector('[name="id"]');
        masterID.tagName == "SELECT" && (masterID.value = this.currentVariant.id);
      }
    }
    getCurrentOptions() {
      let currentOptions = [];
      this.JSON.options.forEach((option, index) => {
        let optionName = `[name="option${index + 1}"]`;
        if (this.querySelector(optionName).tagName == "INPUT") {
          currentOptions.push(this.querySelector(optionName + ":checked")?.value);
        } else {
          currentOptions.push(this.querySelector(optionName)?.value);
        }
      });
      return currentOptions;
    }
    getVariant() {
      const options = this.getCurrentOptions();
      this.currentVariant = this.JSON.variants.find((variant) => {
        return !variant.options.map((option, index) => {
          return options[index] === option;
        }).includes(false);
      });
      if (!this.currentVariant) {
        let selectOptions = Array.from(
          this.querySelectorAll("select[name*=option], input[name*=option]:checked")
        ).filter((i) => i != null);
        if (this.JSON.options.length != selectOptions.length)
          return false;
      }
      return true;
    }
    //   updateURL() {
    //     if (!this.currentVariant) return;
    //     window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    //   }
    updateContent() {
      if (!this.currentVariant)
        return;
      const template = this.template.querySelector(`[data-variant-id="${this.currentVariant.id}"]`);
      this.querySelectorAll(".jsProductUpdate").forEach((node) => {
        const target = template?.querySelector(`[class*="${node.className}"]`);
        if (!target)
          return;
        if (node.classList.contains("jsProductReplace")) {
          node.replaceWith(target);
        } else
          node.innerHTML = target.innerHTML;
      });
    }
    setUnavailable() {
      this.querySelectorAll(".add-to-cart")?.forEach((item) => {
        item.innerHTML = theme.strings.unavailable;
      });
    }
    linkOptions() {
      this.optionsMap = {};
      this.availableOptions = {};
      for (var i = 0; i < this.JSON.variants.length; i++) {
        let variant = this.JSON.variants[i];
        this.optionsMap["root"] = this.optionsMap["root"] || [];
        this.optionsMap["root"].push(variant.option1);
        this.optionsMap["root"] = [...new Set(this.optionsMap["root"])];
        if (this.JSON.options.length > 1) {
          var key = variant.option1;
          this.optionsMap[key] = this.optionsMap[key] || [];
          this.optionsMap[key].push(variant.option2);
          this.optionsMap[key] = [...new Set(this.optionsMap[key])];
        }
        if (this.JSON.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          this.optionsMap[key] = this.optionsMap[key] || [];
          this.optionsMap[key].push(variant.option3);
          this.optionsMap[key] = [...new Set(this.optionsMap[key])];
        }
        if (variant.available) {
          this.availableOptions["root"] = this.availableOptions["root"] || [];
          this.availableOptions["root"].push(variant.option1);
          this.availableOptions["root"] = [...new Set(this.availableOptions["root"])];
          if (this.JSON.options.length > 1) {
            var key = variant.option1;
            this.availableOptions[key] = this.availableOptions[key] || [];
            this.availableOptions[key].push(variant.option2);
            this.availableOptions[key] = [...new Set(this.availableOptions[key])];
          }
          if (this.JSON.options.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            this.availableOptions[key] = this.availableOptions[key] || [];
            this.availableOptions[key].push(variant.option3);
            this.availableOptions[key] = [...new Set(this.availableOptions[key])];
          }
        }
      }
      if (!Array.from(this.querySelectorAll("select[name*=option], input[name*=option]:checked")).filter(
        (i2) => i2 != null
      ).length)
        return;
      this.updateOptionsInSelector(1);
      this.JSON.options.length > 1 && this.updateOptionsInSelector(2);
      this.JSON.options.length === 3 && this.updateOptionsInSelector(3);
    }
    updateOptionsInSelector(index) {
      let key;
      let selector;
      const optionEl = {
        option1: Array.from(this.querySelectorAll("select[name=option1], input[name=option1]:checked")).find(
          (i) => i != null
        ),
        option2: Array.from(this.querySelectorAll("select[name=option2], input[name=option2]:checked")).find(
          (i) => i != null
        ),
        option3: Array.from(this.querySelectorAll("select[name=option3], input[name=option3]:checked")).find(
          (i) => i != null
        )
      };
      switch (index) {
        case 1:
          key = "root";
          selector = optionEl.option1;
          break;
        case 2:
          key = optionEl.option1?.value;
          selector = optionEl.option2;
          break;
        default:
          key = optionEl.option1?.value;
          selector = optionEl.option3;
          key += " / " + optionEl.option2?.value;
          index = 3;
      }
      if (!selector) {
        selector = Array.from(this.querySelectorAll(`select[name=option${index}], input[name=option${index}]`)).find(
          (i) => i != null
        );
      }
      const availableOptions = this.optionsMap[key] || [];
      const optionsValid = this.availableOptions[key] || [];
      const initialValue = selector?.value || "null";
      if (!selector)
        return;
      if (selector.tagName == "SELECT") {
        Array.from(selector.querySelectorAll("option")).forEach((option) => {
          availableOptions.includes(option.value) ? option.removeAttribute("hidden") : option.setAttribute("hidden", "");
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          selector.value = availableOptions[0];
        }
      } else {
        Array.from(this.querySelectorAll(`[name=${selector.name}]`)).forEach((input) => {
          input.classList.toggle("disabled", !optionsValid.includes(input.value));
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          const tempInput = document.createElement("input");
          tempInput.type = "text";
          tempInput.value = availableOptions[0];
          const findAvailableInput = Array.from(this.querySelectorAll(`[name=${selector.name}]`)).find(
            (input) => input.value == tempInput.value
          );
          findAvailableInput && (findAvailableInput.checked = true);
        }
      }
    }
  });

  // app/scripts/common/component/productForm.js
  var { inViewPort: inViewPort2, addEvent: addEvent7 } = theme;
  customElements.define("product-form", class productForm extends HTMLElement {
    connectedCallback() {
      this.JSON = window.theme.product;
      this.linkOptions();
      this.addEventListener("change", this.onChange.bind(this));
      this.template = document.getElementById("productTemplate")?.content || null;
      this.displayPopupEarnPoins();
      this.btnReview = this.querySelector(".product-review-badge .product-review");
      this.btnReview.addEventListener("click", () => {
        document.querySelectorAll(".tab-content--heading").forEach((tab) => {
          if (tab.classList.contains("heading-reviews")) {
            tab.classList.add("active");
          } else {
            tab.classList.remove("active");
          }
        });
        document.querySelectorAll(".tab-content--body").forEach((tab) => {
          if (tab.classList.contains("body-reviews")) {
            tab.classList.add("active");
          } else {
            tab.classList.remove("active");
          }
        });
      });
      addEvent7("click", ".jsProductToggle", (e) => {
        const target = document.querySelector(".jsProductToggleContent");
        if (!target)
          return;
        target.Accordion.open();
      });
    }
    onChange(event) {
      const target = event.target;
      if (!target.classList.contains("js-variant-change"))
        return;
      let index = +target.name.replace(/[^\d]/g, "");
      if (index == 1) {
        this.updateOptionsInSelector(2);
        this.updateOptionsInSelector(3);
      }
      if (index == 2) {
        this.updateOptionsInSelector(3);
      }
      if (!this.getVariant())
        return;
      this.updateMedia();
      this.updateURL();
      if (this.currentVariant) {
        this.updateId();
        this.updateContent();
      } else {
        this.setUnavailable();
      }
      this.closest("[data-section-id]").classList.toggle("variant-soldout", !this.currentVariant?.available || false);
      const { swatchId } = target.dataset;
      this.querySelector(swatchId)?.classList.remove("active");
    }
    updateId() {
      if (this.currentVariant && this.currentVariant.available) {
        const masterID = this.querySelector('[name="id"]');
        masterID.tagName == "SELECT" && (masterID.value = this.currentVariant.id);
      }
    }
    getCurrentOptions() {
      let currentOptions = [];
      this.JSON.options.forEach((option, index) => {
        let optionName = `[name="option${index + 1}"]`;
        if (this.querySelector(optionName).tagName == "INPUT") {
          currentOptions.push(this.querySelector(optionName + ":checked")?.value);
        } else {
          currentOptions.push(this.querySelector(optionName)?.value);
        }
      });
      return currentOptions;
    }
    getVariant() {
      const options = this.getCurrentOptions();
      this.currentVariant = this.JSON.variants.find((variant) => {
        return !variant.options.map((option, index) => {
          return options[index] === option;
        }).includes(false);
      });
      if (!this.currentVariant) {
        let selectOptions = Array.from(
          document.querySelectorAll("select[name*=option], input[name*=option]:checked")
        ).filter((i) => i != null);
        if (this.JSON.options.length != selectOptions.length)
          return false;
      }
      return true;
    }
    updateURL() {
      if (!this.currentVariant)
        return;
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateContent() {
      if (!this.currentVariant)
        return;
      const template = this.template.querySelector(`[data-variant-id="${this.currentVariant.id}"]`);
      document.querySelectorAll(".jsProductUpdate").forEach((node) => {
        const target = template?.querySelector(`[class*="${node.className}"]`);
        if (!target)
          return;
        if (node.classList.contains("jsProductReplace")) {
          node.replaceWith(target);
        } else
          node.innerHTML = target.innerHTML;
      });
    }
    updateMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media)
        return;
      const index = this.currentVariant.featured_media.position - 1;
      document.querySelector("product-slider-component.js-slider-main")?.goTo(index);
    }
    setUnavailable() {
      this.querySelectorAll(".add-to-cart")?.forEach((item) => {
        item.innerHTML = theme.strings.unavailable;
      });
    }
    linkOptions() {
      this.optionsMap = {};
      this.availableOptions = {};
      for (var i = 0; i < this.JSON.variants.length; i++) {
        let variant = this.JSON.variants[i];
        this.optionsMap["root"] = this.optionsMap["root"] || [];
        this.optionsMap["root"].push(variant.option1);
        this.optionsMap["root"] = [...new Set(this.optionsMap["root"])];
        if (this.JSON.options.length > 1) {
          var key = variant.option1;
          this.optionsMap[key] = this.optionsMap[key] || [];
          this.optionsMap[key].push(variant.option2);
          this.optionsMap[key] = [...new Set(this.optionsMap[key])];
        }
        if (this.JSON.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          this.optionsMap[key] = this.optionsMap[key] || [];
          this.optionsMap[key].push(variant.option3);
          this.optionsMap[key] = [...new Set(this.optionsMap[key])];
        }
        if (variant.available) {
          this.availableOptions["root"] = this.availableOptions["root"] || [];
          this.availableOptions["root"].push(variant.option1);
          this.availableOptions["root"] = [...new Set(this.availableOptions["root"])];
          if (this.JSON.options.length > 1) {
            var key = variant.option1;
            this.availableOptions[key] = this.availableOptions[key] || [];
            this.availableOptions[key].push(variant.option2);
            this.availableOptions[key] = [...new Set(this.availableOptions[key])];
          }
          if (this.JSON.options.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            this.availableOptions[key] = this.availableOptions[key] || [];
            this.availableOptions[key].push(variant.option3);
            this.availableOptions[key] = [...new Set(this.availableOptions[key])];
          }
        }
      }
      if (!Array.from(document.querySelectorAll("select[name*=option], input[name*=option]:checked")).filter(
        (i2) => i2 != null
      ).length)
        return;
      this.updateOptionsInSelector(1);
      this.JSON.options.length > 1 && this.updateOptionsInSelector(2);
      this.JSON.options.length === 3 && this.updateOptionsInSelector(3);
    }
    updateOptionsInSelector(index) {
      let key;
      let selector;
      const optionEl = {
        option1: Array.from(document.querySelectorAll("select[name=option1], input[name=option1]:checked")).find(
          (i) => i != null
        ),
        option2: Array.from(document.querySelectorAll("select[name=option2], input[name=option2]:checked")).find(
          (i) => i != null
        ),
        option3: Array.from(document.querySelectorAll("select[name=option3], input[name=option3]:checked")).find(
          (i) => i != null
        )
      };
      switch (index) {
        case 1:
          key = "root";
          selector = optionEl.option1;
          break;
        case 2:
          key = optionEl.option1?.value;
          selector = optionEl.option2;
          break;
        default:
          key = optionEl.option1?.value;
          selector = optionEl.option3;
          key += " / " + optionEl.option2?.value;
          index = 3;
      }
      if (!selector) {
        selector = Array.from(document.querySelectorAll(`select[name=option${index}], input[name=option${index}]`)).find(
          (i) => i != null
        );
      }
      const availableOptions = this.optionsMap[key] || [];
      const optionsValid = this.availableOptions[key] || [];
      const initialValue = selector?.value || "null";
      if (!selector)
        return;
      if (selector.tagName == "SELECT") {
        Array.from(selector.querySelectorAll("option")).forEach((option) => {
          availableOptions.includes(option.value) ? option.removeAttribute("hidden") : option.setAttribute("hidden", "");
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          selector.value = availableOptions[0];
        }
      } else {
        Array.from(this.querySelectorAll(`[name=${selector.name}]`)).forEach((input) => {
          input.classList.toggle("disabled", !optionsValid.includes(input.value));
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          const tempInput = document.createElement("input");
          tempInput.type = "text";
          tempInput.value = availableOptions[0];
          const findAvailableInput = Array.from(this.querySelectorAll(`[name=${selector.name}]`)).find(
            (input) => input.value == tempInput.value
          );
          findAvailableInput && (findAvailableInput.checked = true);
        }
      }
    }
    displayPopupEarnPoins() {
      this.querySelector(".btn-earn-points")?.addEventListener("click", () => {
        this.querySelector(".btn-earn-points").classList.toggle("active");
      });
    }
  });

  // app/scripts/common/component/videoComponent.js
  customElements.define("video-component", class videoComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.addEventListener("touchstart", (e) => e.stopPropagation(), { passive: true });
      this.addEventListener("touchmove", (e) => e.stopPropagation());
      this.addEventListener("touchend", (e) => e.stopPropagation());
      this.addEventListener("mousedown", (e) => e.stopPropagation());
    }
    togglePlay() {
      const { inViewPort: inViewPort3 } = theme;
      this.hasAttribute("play-in-view") && inViewPort3(this, (e) => {
        e ? this.playVideo() : this.stopVideo();
      });
    }
    init() {
      const { type } = this.dataset;
      switch (type) {
        case "youtube":
          this.loadYoutube();
          break;
        case "vimeo":
          this.loadVimeo();
          break;
        case "video":
          this.loadNative();
          break;
      }
    }
    playVideo() {
      if (this.isPlaying)
        return;
      this.isPlaying = true;
      this.classList.add("playing");
      this.videoPlay();
    }
    stopVideo(arg) {
      if (!this.isPlaying)
        return;
      this.classList.remove("playing");
      this.videoStop(arg);
      this.isPlaying = false;
    }
    loadYoutube() {
      if (document.querySelector(`script[src*=youtube][src*=iframe_api]`)) {
        this.loadYoutubeVideo();
        return;
      }
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    loadYoutubeVideo() {
      if (typeof YT == "undefined")
        return;
      const video = this.querySelector("iframe");
      const defaultConfig = `{ "autoplay": 0, "playsinline": 1, "controls": 0, "showinfo": 0, "rel": 0, "loop": 1 }`;
      const playerVars = JSON.parse(video.dataset.config || defaultConfig);
      video.media = new YT.Player(video.id, {
        videoId: video.dataset.ytId,
        playerVars,
        events: {
          "onReady": onPlayerReady.bind(this),
          "onStateChange": onPlayerStateChange.bind(this)
        }
      });
      this.videoPlay = () => {
        video.media?.playVideo();
      };
      this.videoStop = (restart = null) => {
        video.media?.pauseVideo();
        restart && video.media.seekTo(0);
      };
      function onPlayerReady(event) {
        let video2 = event.target;
        const iframe = video2.getIframe();
        if (!iframe.classList.contains("jsAutoPlay"))
          return;
        video2.mute();
        video2.playVideo();
      }
      function onPlayerStateChange(event) {
        const video2 = event.target;
        switch (event.data) {
          case YT.PlayerState.PLAYING:
            this.playVideo();
            break;
          case YT.PlayerState.PAUSED:
            this.stopVideo();
            break;
          case YT.PlayerState.ENDED:
            this.stopVideo(true);
            break;
          default:
            break;
        }
      }
      this.togglePlay();
    }
    loadVimeo() {
      if (document.querySelector(`script[src*=vimeo][src*=player]`)) {
        this.loadVimeoVideo();
        return;
      }
      let tag = document.createElement("script");
      tag.src = "https://player.vimeo.com/api/player.js";
      tag.id = "VMScript";
      tag.onload = this.loadVimeoVideo.bind(this);
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    loadVimeoVideo() {
      if (typeof Vimeo == "undefined")
        return;
      const video = this.querySelector("iframe");
      video.media = new Vimeo.Player(video);
      video.classList.contains("jsAutoPlay") && (video.media.setVolume(0), video.media.play());
      this.videoPlay = () => {
        video.media.play();
      };
      this.videoStop = () => {
        video.media.pause();
      };
      video.media.on("play", () => {
      });
      video.media.on("ended", () => {
        video.media.play();
      });
      this.togglePlay();
    }
    loadNative() {
      const video = this.querySelector("video");
      this.videoPlay = () => {
        video.play();
      };
      this.videoStop = () => {
        video.pause();
      };
      this.togglePlay();
    }
  });
  window["onYouTubeIframeAPIReady"] = () => {
    const selectors2 = `video-component[data-type="youtube"]`;
    document.querySelectorAll(selectors2)?.forEach((video) => video.loadYoutubeVideo());
  };

  // app/scripts/common/component/backInStock.js
  window.customElements.define("back-in-stock", class extends HTMLElement {
    connectedCallback() {
      this.querySelector('[type="submit"]').addEventListener("click", this.initEvents.bind(this));
    }
    initEvents(e) {
      e.preventDefault();
      const formType = this.querySelector('[name="backInStockFormType"]:checked').value;
      let email = this.querySelector('[type="email"]')?.value;
      let phoneNumber = this.querySelector('[type="text"]')?.value;
      if (formType == "phone" && phoneNumber == "")
        return;
      if (formType == "email" && email == "")
        return;
      e.preventDefault();
      const { variantID, productID } = this.querySelector('[name="productData"]').dataset;
      let accepts_marketing = this.querySelector("#back-in-stock-marketing")?.checked || null;
      let attributes = {};
      if (formType == "phone") {
        email = null;
        attributes = { phone_number: phoneNumber };
      }
      attributes = { ...attributes, accepts_marketing };
      SI.create(email, variantID, productID, attributes).then((resp) => {
        this.classList.add("form-success");
        this.querySelector(".jsValue").innerHTML = formType == "phone" ? phoneNumber : email;
      });
    }
  });

  // app/scripts/common/component/stickyHeader.js
  var StickyHeader = class extends HTMLElement {
    constructor() {
      super();
      const stickyDirection = this.dataset.sticky || "down";
      stickyDirection == "up" && this.closest("header").setAttribute("data-sticky", "up");
      this.setHeight();
      const resizeObserver = new ResizeObserver((entries) => {
        this.setHeight();
      });
      resizeObserver.observe(this);
    }
    setHeight() {
      document.documentElement.style.setProperty("--header-height", this.closest("header").scrollHeight + "px");
      window.addEventListener("resize", () => {
        document.documentElement.style.setProperty("--header-height", this.closest("header").scrollHeight + "px");
      });
    }
    connectedCallback() {
      this.header = document.querySelector("header");
      this.headerBounds = this.header.getBoundingClientRect();
      this.currentScrollTop = this.header.getBoundingClientRect().bottom || 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScrollHandler, false);
      this.createObserver();
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer2) => {
        this.headerBounds = entries[0].intersectionRect;
        observer2.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.closest("header").scrollHeight + 150) {
        this.hide();
      } else {
        this.reset();
      }
      return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add("header-sticky");
    }
    reveal() {
      this.header.classList.add("header-sticky", "is-scrolling-up");
      this.header.classList.remove("is-scrolling-down");
    }
    reset() {
      this.header.classList.remove("header-sticky", "is-scrolling-up");
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll("details-disclosure");
      this.disclosures?.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector("details-modal");
      this.searchModal?.close(false);
    }
  };
  !customElements.get("sticky-header") && customElements.define("sticky-header", StickyHeader);

  // app/scripts/common/component/stickyMobileBar.js
  var stickyMobileBar = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      document.documentElement.style.setProperty("--padding-bottom", this.scrollHeight + "px");
    }
  };
  !customElements.get("sticky-mobile-bar") && customElements.define("sticky-mobile-bar", stickyMobileBar);

  // app/scripts/common/sections/header.js
  var header_default = Header = {
    init() {
      this.container = this.container || document.querySelector('[data-section-type="header-section"]');
      this.container.querySelectorAll(".list-item a").forEach((a) => {
        a.addEventListener("mouseenter", this.onNavHover.bind(this, a), { once: true });
        a.addEventListener("focusin", (e) => {
          a.closest("li").classList.add("is-focusing");
          this.onNavHover(a);
          this.container.querySelectorAll(".dropdown-is-showing")?.forEach((item) => {
            item.classList.remove("dropdown-is-showing");
          });
        });
        a.addEventListener("focusout", (e) => {
          setTimeout(() => {
            !a.closest("li").querySelectorAll(".is-focusing").length && a.closest("li").classList.remove("is-focusing");
          }, 100);
        });
      });
      this.container.querySelectorAll(".jsFocus").forEach((item) => {
        item.addEventListener("focusin", (e) => {
          item.classList.add("is-focusing");
        });
        item.addEventListener("focusout", (e) => {
          item.classList.remove("is-focusing");
        });
      });
    },
    onNavHover(el) {
      const nav = el;
      const template = nav.parentNode.querySelector(".jsTemplate");
      if (!template)
        return;
      template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
        template.insertAdjacentElement("beforebegin", child);
      });
      template.tagName == "NOSCRIPT" && template.insertAdjacentHTML("beforebegin", template.textContent);
      template.remove();
      const parentNode = nav.parentNode;
      parentNode.classList.add("has-dropdown");
      parentNode.querySelector(":scope > a ~ template")?.remove();
      parentNode.querySelectorAll("a").forEach((a) => {
        a.addEventListener("focusin", (e) => {
          a.classList.add("is-focusing");
        });
        a.addEventListener("focusout", (e) => {
          a.classList.remove("is-focusing");
          setTimeout(() => {
            !parentNode.querySelectorAll(".is-focusing").length && parentNode.classList.remove("is-focusing");
          }, 100);
        });
      });
      const linkToOpen = parentNode.querySelector(":scope > a");
      !linkToOpen.classList.contains("dropdown-trigger") && linkToOpen.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.container.querySelectorAll(".dropdown-is-showing")?.forEach((item) => {
          item != parentNode && item.classList.remove("dropdown-is-showing");
        });
        parentNode.classList.toggle("dropdown-is-showing");
        parentNode.classList.remove("is-focusing");
      });
      linkToOpen.classList.add("dropdown-trigger");
    },
    onLoad: function() {
      this.init();
    }
  };

  // app/scripts/theme.js
  var { editor, addEvent: addEvent8, routes: { pageType: pageType2 }, sessionStorage: sessionStorage2 } = theme;
  !editor && header_default.init();
  addEvent8("click", "body", (e) => {
    if (!e.target.closest('a[href="#PodiumWebChat"]'))
      return;
    e.preventDefault();
    PodiumWebChat.open();
  });
  if (pageType2 != "customers/register") {
    (async () => {
      const formStorage = sessionStorage2("accountRegisterForm");
      const value = formStorage.get() || "";
      value.split(",").forEach((key) => {
        sessionStorage2(key).clearAll();
      });
    })();
  }
})();